import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState, useCallback } from 'react';
import axios from 'axios';
import JsBarcode from 'jsbarcode';
import HanjinWaybill from '../components/waybill/HanjinWaybill';
import KyungdongWaybill from '../components/waybill/KyungdongWaybill';
import CheonilWaybill from '../components/waybill/CheonilWaybill';
import { getCourierType } from '../utils/waybillUtils';
import { getPrintOrders } from '../api/printOrderService';
import { getOrdersByNumbers } from '../api/orderService';
import { API_BASE_URL } from '../api/axiosConfig';
import { normalizeKoreanText } from '../utils/fixKoreanText';
const CHEONIL_PRINT_BATCH_SIZE = 20;
function chunkArray(items, size) {
    const normalizedSize = Math.max(1, Number(size || 1) || 1);
    const chunks = [];
    for (let index = 0; index < items.length; index += normalizedSize) {
        chunks.push(items.slice(index, index + normalizedSize));
    }
    return chunks;
}
function maskName(name) {
    if (!name || name.length < 2)
        return name;
    if (name.length === 2) {
        // cleaned legacy comment
        return name[0] + '*';
    }
    // cleaned legacy comment
    return name[0] + '*'.repeat(name.length - 2) + name[name.length - 1];
}
function getBoxTypCdByFee(fee) {
    const map = {
        '2500': 'A',
        '3000': 'B',
        '4000': 'C',
        '5000': 'D',
    };
    return map[String(fee)] || 'A'; // 湲곕낯媛?'A'
}
function maskPhone(phone) {
    if (!phone)
        return phone;
    // cleaned legacy comment
    const normalized = String(phone);
    const digits = normalized.replace(/[^0-9]/g, '');
    if (digits.length < 4)
        return phone;
    const masked = digits.slice(0, -4) + '****';
    // cleaned legacy comment
    if (normalized.includes('-')) {
        return masked.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-****');
    }
    return masked;
}
function maskDetailAddress(address) {
    if (!address)
        return address;
    const idx = address.lastIndexOf(' ');
    if (idx === -1)
        return address;
    return address.slice(0, idx) + ' ****';
}
function buildLocalKyungdongBundleAddonMessage(rawMessage) {
    const normalizedMessage = String(rawMessage || '').trim();
    if (!normalizedMessage) {
        return '';
    }
    const [rawProductList] = normalizedMessage
        .split('|')
        .map((segment) => String(segment || '').trim());
    if (!rawProductList || !rawProductList.includes(',')) {
        return '';
    }
    const productItems = rawProductList
        .split(',')
        .map((item) => String(item || '').trim())
        .filter(Boolean);
    if (productItems.length <= 1) {
        return '';
    }
    return productItems.slice(1).join(', ').trim();
}
const PrintWblPopup = () => {
    const searchParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
    const [wblDataList, setWblDataList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [order, setOrder] = useState(null);
    // cleaned legacy comment
    const isInitialized = useRef(false);
    const hasTriggeredPrintRef = useRef(false);
    const isReissueMode = searchParams.get('mode') === 'reissue';
    // 諛붿퐫??李몄“
    const tmlBarcodeRefs = useRef([]);
    const wblNumBarcodeRefs = useRef([]);
    const buildFallbackWaybillFromOrder = useCallback((orderItem, courierType, reason, trackingOverride) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        const trackingNo = String(trackingOverride ||
            ((_a = orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderData) === null || _a === void 0 ? void 0 : _a.tracking_number) ||
            ((_b = orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderData) === null || _b === void 0 ? void 0 : _b.tracking_no) ||
            ((_c = orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderData) === null || _c === void 0 ? void 0 : _c.wbl_num) ||
            '').trim();
        if (!trackingNo) {
            return null;
        }
        return {
            wbl_num: trackingNo,
            orderNumber: orderItem.orderNumber,
            orderInfo: {
                order_number: orderItem.orderNumber,
                recipient_name: ((_d = orderItem.orderData) === null || _d === void 0 ? void 0 : _d.recipient_name) || '',
                address: ((_e = orderItem.orderData) === null || _e === void 0 ? void 0 : _e.address) || '',
                zip_code: ((_f = orderItem.orderData) === null || _f === void 0 ? void 0 : _f.zip_code) || '',
                mobile_phone: ((_g = orderItem.orderData) === null || _g === void 0 ? void 0 : _g.mobile_phone) || '',
                order_date: ((_h = orderItem.orderData) === null || _h === void 0 ? void 0 : _h.order_date) || ((_j = orderItem.orderData) === null || _j === void 0 ? void 0 : _j.created_at) || '',
                quantity: Number((_k = orderItem.orderData) === null || _k === void 0 ? void 0 : _k.quantity) || 1,
                boxqty: Number((_l = orderItem.orderData) === null || _l === void 0 ? void 0 : _l.box_qty) || 1,
                message: ((_m = orderItem.orderData) === null || _m === void 0 ? void 0 : _m.message) || ((_o = orderItem.orderData) === null || _o === void 0 ? void 0 : _o.order_memo) || '',
                ship_comp: courierType === 'hanjin' ? '한진' : '천일'
            },
            productInfo: {
                product_name: ((_p = orderItem.productData) === null || _p === void 0 ? void 0 : _p.product_name) || ((_q = orderItem.orderData) === null || _q === void 0 ? void 0 : _q.product_name) || '',
                product_code: orderItem.productCode || ((_r = orderItem.orderData) === null || _r === void 0 ? void 0 : _r.product_code) || '',
                description: reason || '',
                courier_fee: Number(((_s = orderItem.orderData) === null || _s === void 0 ? void 0 : _s.ship_comp_fee) || ((_t = orderItem.orderData) === null || _t === void 0 ? void 0 : _t.shipping_fee)) || 0,
                ship_comp: courierType === 'hanjin' ? '한진' : '천일'
            },
            quantityIndex: orderItem.quantityIndex || 0,
            boxIndex: orderItem.boxIndex || 1,
            locationInfo: orderItem.locationInfo,
            productCode: orderItem.productCode || ((_u = orderItem.orderData) === null || _u === void 0 ? void 0 : _u.product_code) || '',
            courier_type: courierType,
            _fallback: true
        };
    }, []);
    const hanjinRoutingKeys = [
        'hub_cod',
        'tml_cod',
        'dom_mid',
        'es_cod',
        'cen_cod',
        'cen_nam',
        'grp_rnk',
        'es_nam',
        'dom_rgn',
        's_tml_cod',
        's_tml_nam'
    ];
    const enrichHanjinOfficeInfo = useCallback((target, fallback) => {
        if (!target)
            return target;
        const merged = { ...target };
        if (fallback) {
            hanjinRoutingKeys.forEach((key) => {
                if (!String((merged === null || merged === void 0 ? void 0 : merged[key]) || '').trim() && String((fallback === null || fallback === void 0 ? void 0 : fallback[key]) || '').trim()) {
                    merged[key] = fallback[key];
                }
            });
        }
        const officeCode = String(merged.s_tml_cod ||
            merged.tml_cod ||
            merged.cen_cod ||
            (fallback === null || fallback === void 0 ? void 0 : fallback.office_code) ||
            '').trim();
        const officeName = String(merged.s_tml_nam ||
            merged.cen_nam ||
            merged.es_nam ||
            (fallback === null || fallback === void 0 ? void 0 : fallback.office_name) ||
            '').trim();
        if (officeCode) {
            merged.office_code = officeCode;
        }
        if (officeName) {
            merged.office_name = officeName;
        }
        if (!String(merged.s_tml_cod || '').trim() && officeCode) {
            merged.s_tml_cod = officeCode;
        }
        if (!String(merged.s_tml_nam || '').trim() && officeName) {
            merged.s_tml_nam = officeName;
        }
        return merged;
    }, []);
    const buildIssuedHanjinWaybillData = useCallback((orderItem, boxIndex, totalCount, issuedResult, fallbackMeta) => {
        const resultSource = {
            ...((issuedResult === null || issuedResult === void 0 ? void 0 : issuedResult.data) || {}),
            ...(issuedResult || {})
        };
        const baseOrderInfo = (orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderData) || (orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderInfo) || {};
        const orderInfo = {
            ...baseOrderInfo,
            message: String((baseOrderInfo === null || baseOrderInfo === void 0 ? void 0 : baseOrderInfo.message) || '').trim() ||
                String((baseOrderInfo === null || baseOrderInfo === void 0 ? void 0 : baseOrderInfo.order_memo) || '').trim() ||
                ''
        };
        const baseProductInfo = (orderItem === null || orderItem === void 0 ? void 0 : orderItem.productData) || (orderItem === null || orderItem === void 0 ? void 0 : orderItem.productInfo) || {};
        const productInfo = {
            ...baseProductInfo,
            product_name: String((resultSource === null || resultSource === void 0 ? void 0 : resultSource.product_name) || '').trim() ||
                String((baseProductInfo === null || baseProductInfo === void 0 ? void 0 : baseProductInfo.product_name) || '').trim() ||
                String((orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.product_name) || '').trim() ||
                '',
            product_code: String((resultSource === null || resultSource === void 0 ? void 0 : resultSource.product_code) || '').trim() ||
                String((baseProductInfo === null || baseProductInfo === void 0 ? void 0 : baseProductInfo.product_code) || '').trim() ||
                String((orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.product_code) || '').trim() ||
                '',
        };
        const resolvedBoxIndex = Number((orderItem === null || orderItem === void 0 ? void 0 : orderItem.boxIndex) || boxIndex + 1) || boxIndex + 1;
        const resolvedLabelSequence = Number(orderItem === null || orderItem === void 0 ? void 0 : orderItem.labelSequence) ||
            Number(orderItem === null || orderItem === void 0 ? void 0 : orderItem.quantityIndex) ||
            resolvedBoxIndex ||
            1;
        const orderNumber = (orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderNumber) || (orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.order_number) || '';
        const issuedTrackingNo = String((resultSource === null || resultSource === void 0 ? void 0 : resultSource.wbl_num) ||
            (resultSource === null || resultSource === void 0 ? void 0 : resultSource.wblNo) ||
            '').trim();
        if (!issuedTrackingNo) {
            return null;
        }
        const issuedWaybillData = {
            ...resultSource,
            wbl_num: issuedTrackingNo,
            wblNo: issuedTrackingNo,
            sequenceNumber: Number((orderItem === null || orderItem === void 0 ? void 0 : orderItem.sequenceNumber) || 0) || resolvedLabelSequence,
            totalCount,
            quantityIndex: Number((orderItem === null || orderItem === void 0 ? void 0 : orderItem.quantityIndex) || 0),
            boxIndex: resolvedBoxIndex,
            labelSequence: resolvedLabelSequence,
            orderInfo,
            orderNumber,
            productInfo,
            locationInfo: orderItem === null || orderItem === void 0 ? void 0 : orderItem.locationInfo,
            productCode: (productInfo === null || productInfo === void 0 ? void 0 : productInfo.product_code) || (orderItem === null || orderItem === void 0 ? void 0 : orderItem.productCode) || (orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.product_code) || '',
            ship_order_id: (resultSource === null || resultSource === void 0 ? void 0 : resultSource.ship_order_id) || `${orderNumber}-${String(resolvedLabelSequence).padStart(2, '0')}`,
            courier_type: 'hanjin'
        };
        issuedWaybillData.boxType = (resultSource === null || resultSource === void 0 ? void 0 : resultSource.boxtype) || (resultSource === null || resultSource === void 0 ? void 0 : resultSource.boxType) || '';
        return enrichHanjinOfficeInfo(issuedWaybillData, fallbackMeta);
    }, [enrichHanjinOfficeInfo]);
    const mergeHanjinRoutingMeta = useCallback((target, fallback) => {
        if (!target || !fallback)
            return target;
        return enrichHanjinOfficeInfo(target, fallback);
    }, [enrichHanjinOfficeInfo]);
    const backfillHanjinOfficeInfo = useCallback((list) => {
        if (!Array.isArray(list) || list.length === 0)
            return list;
        const source = list.find((item) => hanjinRoutingKeys.some((key) => String((item === null || item === void 0 ? void 0 : item[key]) || '').trim()) ||
            String((item === null || item === void 0 ? void 0 : item.office_code) || '').trim() ||
            String((item === null || item === void 0 ? void 0 : item.office_name) || '').trim());
        if (!source)
            return list;
        return list.map((item) => enrichHanjinOfficeInfo(item, source));
    }, [enrichHanjinOfficeInfo]);
    // cleaned legacy comment
    const sendToHanjin = async (wblData) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        const orderNumber = ((_a = wblData.orderInfo) === null || _a === void 0 ? void 0 : _a.order_number) || wblData.orderNumber || '';
        try {
            const boxIndex = wblData.boxIndex || 1;
            const labelSequence = Number(wblData.labelSequence) || wblData.quantityIndex || boxIndex || 1;
            const shipOrderId = `${orderNumber}-${String(labelSequence).padStart(2, '0')}`;
            const orderData = {
                wbl_num: wblData.wbl_num || wblData.wblNo || '',
                order_number: orderNumber,
                ship_order_id: shipOrderId,
                box_index: boxIndex,
                is_reissue: isReissueMode,
                recipient_name: ((_b = wblData.orderInfo) === null || _b === void 0 ? void 0 : _b.recipient_name) || '',
                address: ((_c = wblData.orderInfo) === null || _c === void 0 ? void 0 : _c.address) || '',
                zip_code: ((_d = wblData.orderInfo) === null || _d === void 0 ? void 0 : _d.zip_code) || '',
                mobile_phone: ((_e = wblData.orderInfo) === null || _e === void 0 ? void 0 : _e.mobile_phone) || '',
                product_name: ((_f = wblData.productInfo) === null || _f === void 0 ? void 0 : _f.product_name) || '',
                quantity: 1
            };
            const response = await axios.post(`${API_BASE_URL}/api/courier/transfer-single-to-hanjin`, orderData);
            if (response.data.success) {
                const responsePayload = ((_g = response.data) === null || _g === void 0 ? void 0 : _g.data) || {};
                const issuedTrackingNo = String(((_h = response.data) === null || _h === void 0 ? void 0 : _h.wbl_num) ||
                    (responsePayload === null || responsePayload === void 0 ? void 0 : responsePayload.wbl_num) ||
                    (responsePayload === null || responsePayload === void 0 ? void 0 : responsePayload.wblNo) ||
                    orderData.wbl_num ||
                    '').trim();
                return {
                    success: true,
                    message: response.data.message,
                    ...responsePayload,
                    data: responsePayload,
                    ship_order_id: shipOrderId,
                    boxtype: responsePayload === null || responsePayload === void 0 ? void 0 : responsePayload.boxtype,
                    wbl_num: issuedTrackingNo,
                    wblNo: issuedTrackingNo
                };
            }
            else {
                console.error('한진택배 API 실패:', response.data);
                const apiCode = ((_j = response.data) === null || _j === void 0 ? void 0 : _j.error_code) || ((_k = response.data) === null || _k === void 0 ? void 0 : _k.code) || ((_l = response.data) === null || _l === void 0 ? void 0 : _l.resultCode) || response.status || 'UNKNOWN';
                throw new Error(`[order:${orderNumber}][code:${apiCode}] ${normalizeKoreanText(response.data.message || '한진택배 API 호출 실패')}`);
            }
        }
        catch (error) {
            console.error('=== sendToHanjin 오류 ===');
            console.error('오류 이름:', error.name);
            console.error('오류 메시지:', error.message);
            console.error('오류 상세:', error);
            if (error.response) {
                console.error('응답 상태:', error.response.status);
                console.error('응답 데이터:', error.response.data);
            }
            console.error('=== sendToHanjin 오류 끝 ===');
            return {
                success: false,
                message: `[order:${orderNumber}][code:${((_m = error.response) === null || _m === void 0 ? void 0 : _m.status) || ((_p = (_o = error.response) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.error_code) || ((_r = (_q = error.response) === null || _q === void 0 ? void 0 : _q.data) === null || _r === void 0 ? void 0 : _r.code) || 'UNKNOWN'}] ${normalizeKoreanText(((_t = (_s = error.response) === null || _s === void 0 ? void 0 : _s.data) === null || _t === void 0 ? void 0 : _t.message) || error.message || '한진택배 API 호출 중 오류가 발생했습니다.')}`
            };
        }
    };
    // cleaned legacy comment
    const getTrackingNumber = async (orderNumber) => {
        var _a;
        try {
            const response = await fetch(`${API_BASE_URL}/api/orders/order/${orderNumber}`);
            if (response.ok) {
                const data = await response.json();
                return ((_a = data.data) === null || _a === void 0 ? void 0 : _a.tracking_number) || null;
            }
        }
        catch (error) {
            console.error('원래 운송장번호 조회 오류:', error);
        }
        return null;
    };
    const getTrackingNumber2 = async (orderNumber) => {
        var _a;
        try {
            const response = await fetch(`${API_BASE_URL}/api/orders/get/orderseq/${orderNumber}`);
            if (response.ok) {
                const data = await response.json();
                return ((_a = data.data) === null || _a === void 0 ? void 0 : _a.tracking_no) || null;
            }
        }
        catch (error) {
            console.error('원래 운송장번호 조회 오류:', error);
        }
        return null;
    };
    const getOrderSeqEntry = async (orderNumber) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/orders/get/orderseq/${orderNumber}`);
            if (response.ok) {
                const data = await response.json();
                return data.data || null;
            }
        }
        catch (error) {
            console.error('주문 seq 조회 오류:', error);
        }
        return null;
    };
    const getOrderSeqEntries = async (orderNumber) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/orders/get/orderseq-list/${orderNumber}`);
            if (response.ok) {
                const data = await response.json();
                return Array.isArray(data.data) ? data.data : [];
            }
        }
        catch (error) {
            console.error('주문 seq 목록 조회 오류:', error);
        }
        return [];
    };
    const buildSeqLocationInfo = useCallback((seqEntry, fallback) => {
        const A = String((seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.A) || (fallback === null || fallback === void 0 ? void 0 : fallback.A) || '').trim();
        const B = String((seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.B) || (fallback === null || fallback === void 0 ? void 0 : fallback.B) || '').trim();
        const C = String((seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.C) || (fallback === null || fallback === void 0 ? void 0 : fallback.C) || '').trim();
        const productCode = String((seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.product_code) ||
            (fallback === null || fallback === void 0 ? void 0 : fallback.productCode) ||
            (fallback === null || fallback === void 0 ? void 0 : fallback.product_code) ||
            '').trim();
        if (!A && !B && !C) {
            return fallback || null;
        }
        return {
            A: A || 'Z',
            B: B || 'Z',
            C: C || 'Z',
            locationSort: `${A || 'Z'}-${B || 'Z'}-${C || 'Z'}-${productCode || 'UNKNOWN'}`
        };
    }, []);
    const extractShipOrderSequence = useCallback((shipOrderId, fallback) => {
        const normalizedShipOrderId = String(shipOrderId || '').trim();
        const match = normalizedShipOrderId.match(/[-_](\d+)$/);
        if (!match) {
            return fallback;
        }
        const parsed = Number(match[1]);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
    }, []);
    const buildHanjinPrintTargets = useCallback(async (orderItem) => {
        var _a, _b, _c, _d, _e;
        const seqEntries = await getOrderSeqEntries(orderItem.orderNumber);
        const normalizedSeqEntries = Array.isArray(seqEntries)
            ? seqEntries.slice().sort((a, b) => Number((a === null || a === void 0 ? void 0 : a.id) || 0) - Number((b === null || b === void 0 ? void 0 : b.id) || 0))
            : [];
        const uniqueTargets = [];
        const seenKeys = new Set();
        normalizedSeqEntries.forEach((seqEntry, seqIndex) => {
            const trackingNo = String((seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.tracking_no) || '').trim();
            const shipOrderId = String((seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.ship_order_id) || '').trim();
            const dedupeKey = trackingNo || shipOrderId || `${orderItem.orderNumber}-${seqIndex + 1}`;
            if (!dedupeKey || seenKeys.has(dedupeKey)) {
                return;
            }
            seenKeys.add(dedupeKey);
            uniqueTargets.push({
                seqEntry,
                trackingNo,
                shipOrderId,
                labelSequence: extractShipOrderSequence(shipOrderId, uniqueTargets.length + 1),
                locationInfo: buildSeqLocationInfo(seqEntry, orderItem.locationInfo)
            });
        });
        if (uniqueTargets.length > 0) {
            return uniqueTargets;
        }
        const boxQty = Math.max(1, Number((_e = (_d = (_b = (_a = orderItem.orderData) === null || _a === void 0 ? void 0 : _a.box_qty) !== null && _b !== void 0 ? _b : (_c = orderItem.orderData) === null || _c === void 0 ? void 0 : _c.boxQty) !== null && _d !== void 0 ? _d : orderItem.boxQty) !== null && _e !== void 0 ? _e : 1) || 1);
        return Array.from({ length: boxQty }, (_, index) => ({
            seqEntry: null,
            trackingNo: '',
            shipOrderId: `${orderItem.orderNumber}-${String(index + 1).padStart(2, '0')}`,
            labelSequence: index + 1,
            locationInfo: orderItem.locationInfo
        }));
    }, [buildSeqLocationInfo, extractShipOrderSequence]);
    const resolveFallbackTrackingNumber = async (orderItem) => {
        var _a, _b, _c;
        const embeddedTracking = String(((_a = orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderData) === null || _a === void 0 ? void 0 : _a.tracking_number) ||
            ((_b = orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderData) === null || _b === void 0 ? void 0 : _b.tracking_no) ||
            ((_c = orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderData) === null || _c === void 0 ? void 0 : _c.wbl_num) ||
            '').trim();
        if (embeddedTracking) {
            return embeddedTracking;
        }
        const orderNumber = String((orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderNumber) || '').trim();
        if (!orderNumber) {
            return null;
        }
        const orderSeqTracking = await getTrackingNumber2(orderNumber);
        if (orderSeqTracking) {
            return orderSeqTracking;
        }
        const orderTracking = await getTrackingNumber(orderNumber);
        if (orderTracking) {
            return orderTracking;
        }
        return null;
    };
    // cleaned legacy comment
    const createKyungdongWblData = async (orderItem) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        try {
            const seqEntry = orderItem.seqEntry || await getOrderSeqEntry(orderItem.orderNumber);
            const seqQuantity = Math.max(1, Number((_b = (_a = seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.quantity) !== null && _a !== void 0 ? _a : orderItem.splitQuantity) !== null && _b !== void 0 ? _b : 1) || 1);
            // 癒쇱? tracking_number 議고쉶
            const trackingNumber = String((seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.tracking_no) ||
                await resolveFallbackTrackingNumber(orderItem) ||
                '').trim();
            if (!trackingNumber) {
                console.error('경동택배 원래 운송장번호를 찾을 수 없음:', orderItem.orderNumber);
                return null;
            }
            // cleaned legacy comment
            const response = await axios.post(`${API_BASE_URL}/api/proxy/print-wbl-kyungdong`, {
                prodCodes: [trackingNumber] // 원래 운송장번호로 조회
            });
            if (response.data.success && response.data.data.data.list.length > 0) {
                const kyungdongData = response.data.data.data.list[0];
                const rawProductName = String(kyungdongData.product.name || '').trim();
                const rawMemo1 = String(kyungdongData.product.memo1 || '').trim();
                const rawMemo2 = String(kyungdongData.product.memo2 || '').trim();
                const apiQuantity = Math.max(1, Number((_e = (_d = (_c = kyungdongData.product.count) !== null && _c !== void 0 ? _c : seqQuantity) !== null && _d !== void 0 ? _d : orderItem.displayQuantity) !== null && _e !== void 0 ? _e : 1) || 1);
                const resolvedOriginalQuantity = Math.max(apiQuantity, Number((_h = (_f = orderItem.originalQuantity) !== null && _f !== void 0 ? _f : (_g = orderItem.orderData) === null || _g === void 0 ? void 0 : _g.quantity) !== null && _h !== void 0 ? _h : apiQuantity) || apiQuantity);
                const resolvedTotalQuantity = Math.max(resolvedOriginalQuantity, Number((_l = (_j = orderItem.totalQuantity) !== null && _j !== void 0 ? _j : (_k = orderItem.orderData) === null || _k === void 0 ? void 0 : _k.quantity) !== null && _l !== void 0 ? _l : resolvedOriginalQuantity) || resolvedOriginalQuantity);
                const baseProductName = String((_r = (_q = (_p = (_m = seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.product_name) !== null && _m !== void 0 ? _m : (_o = orderItem.orderData) === null || _o === void 0 ? void 0 : _o.product_name) !== null && _p !== void 0 ? _p : orderItem.product_name) !== null && _q !== void 0 ? _q : rawProductName) !== null && _r !== void 0 ? _r : '').trim();
                const fallbackBundleLabel = baseProductName && seqQuantity > 1
                    ? `${baseProductName}_${seqQuantity}개`
                    : (baseProductName || rawProductName);
                const hasBundleSignal = /합포장|상담처리/i.test(`${rawProductName} ${rawMemo1} ${rawMemo2}`.trim());
                const localBundleAddonMessage = buildLocalKyungdongBundleAddonMessage(String(((_s = orderItem.orderData) === null || _s === void 0 ? void 0 : _s.message) || '').trim());
                const memoLooksLikeMainProduct = [rawProductName, baseProductName]
                    .filter(Boolean)
                    .some((name) => rawMemo1 === name || rawMemo1.startsWith(`${name}_`) || rawMemo1.startsWith(`${name} `));
                const shouldPreferLocalProductName = !!baseProductName &&
                    baseProductName !== rawProductName &&
                    (hasBundleSignal || !!localBundleAddonMessage);
                const shouldPreferLocalBundleMessage = !!localBundleAddonMessage &&
                    (!rawMemo1 || memoLooksLikeMainProduct);
                const displayProductName = shouldPreferLocalProductName
                    ? baseProductName
                    : (rawProductName || fallbackBundleLabel);
                const displayMemo1 = shouldPreferLocalBundleMessage
                    ? localBundleAddonMessage
                    : rawMemo1 || (hasBundleSignal &&
                        fallbackBundleLabel &&
                        fallbackBundleLabel !== displayProductName
                        ? fallbackBundleLabel
                        : '');
                const displayMemo2 = rawMemo2;
                const displayArrivalNosun = kyungdongData.product.arrivalNosun ||
                    ((_t = kyungdongData.arrivalBranch) === null || _t === void 0 ? void 0 : _t.name) ||
                    '';
                // cleaned legacy comment
                return {
                    orderInfo: {
                        order_number: orderItem.orderNumber,
                        recipient_name: kyungdongData.receiver.name,
                        address: kyungdongData.receiver.address,
                        zip_code: kyungdongData.receiver.zipCode,
                        mobile_phone: kyungdongData.receiver.telNo,
                        order_date: kyungdongData.product.sendDay,
                        quantity: apiQuantity,
                        boxqty: 1,
                        ship_comp: '\uACBD\uB3D9'
                    },
                    orderNumber: orderItem.orderNumber,
                    productInfo: {
                        product_name: displayProductName,
                        product_code: orderItem.productCode,
                        description: displayMemo1,
                        courier_fee: 0,
                        ship_comp: '\uACBD\uB3D9'
                    },
                    wbl_num: kyungdongData.product.code,
                    quantityIndex: orderItem.quantityIndex,
                    boxIndex: orderItem.boxIndex,
                    productCode: kyungdongData.product.product_code,
                    displayQuantity: apiQuantity,
                    splitQuantity: seqQuantity,
                    originalQuantity: resolvedOriginalQuantity,
                    totalQuantity: resolvedTotalQuantity,
                    // cleaned legacy comment
                    kyungdong_data: {
                        sendDay: kyungdongData.product.sendDay,
                        sendTime: kyungdongData.product.sendTime,
                        corpType: kyungdongData.product.corpType,
                        pay: kyungdongData.product.pay,
                        wrap: kyungdongData.product.wrap,
                        memo1: displayMemo1,
                        memo2: displayMemo2,
                        departureNosun: kyungdongData.product.departureNosun,
                        arrivalNosun: displayArrivalNosun,
                        driverForPickup: kyungdongData.product.driverForPickup,
                        driverForDelivery: kyungdongData.product.driverForDelivery,
                        delivery: kyungdongData.product.delivery,
                        departBranch: kyungdongData.departBranch,
                        arrivalBranch: kyungdongData.arrivalBranch,
                        fare: kyungdongData.fare,
                        volume: kyungdongData.volume,
                        sender: kyungdongData.sender,
                        receiver: kyungdongData.receiver,
                        corp: kyungdongData.corp,
                        code: kyungdongData.code,
                        copies: kyungdongData.copies
                    }
                };
            }
            else {
                console.error('경동택배 API 응답 오류:', response.data);
                return null;
            }
        }
        catch (error) {
            console.error('경동택배 API 호출 오류:', error);
            return null;
        }
    };
    // cleaned legacy comment
    const createCheonilWblData = async (orderItem) => {
        var _a, _b, _c, _d;
        try {
            // cleaned legacy comment
            const response = await axios.post(`${API_BASE_URL}/api/proxy/print-wbl-cheonil2`, {
                orderNumbers: [orderItem.orderNumber],
                is_reissue: isReissueMode
            });
            if (response.data.success && ((_a = response.data.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const wblDataList = [];
                // cleaned legacy comment
                for (let i = 0; i < response.data.data.length; i++) {
                    const cheonilData = response.data.data[i] || {};
                    const cheonilLocation = cheonilData.locationInfo || {};
                    const cheonilInterf = { ...(((_b = cheonilData.cheonil_data) === null || _b === void 0 ? void 0 : _b.interf) || {}) };
                    const cheonilIntern = { ...(((_c = cheonilData.cheonil_data) === null || _c === void 0 ? void 0 : _c.intern) || {}) };
                    const normalizedTrackingNo = String(cheonilIntern.asitnb ||
                        cheonilInterf.mainnb ||
                        cheonilData.wbl_num ||
                        cheonilData.trackingNumber ||
                        '').trim();
                    if (normalizedTrackingNo) {
                        cheonilIntern.asitnb = normalizedTrackingNo;
                        cheonilIntern.mainnb = normalizedTrackingNo;
                        cheonilInterf.mainnb = normalizedTrackingNo;
                    }
                    // cleaned legacy comment
                    const wblData = {
                        orderInfo: {
                            order_number: orderItem.orderNumber,
                            recipient_name: cheonilData.recipient_name,
                            address: cheonilData.address,
                            zip_code: cheonilData.zip_code,
                            mobile_phone: cheonilData.mobile_phone,
                            order_date: cheonilData.order_date,
                            quantity: cheonilData.quantity,
                            message: cheonilData.message || cheonilData.special_note || ((_d = orderItem.orderData) === null || _d === void 0 ? void 0 : _d.message) || '',
                            boxqty: 1,
                            ship_comp: '\uCC9C\uC77C'
                        },
                        orderNumber: orderItem.orderNumber,
                        productInfo: {
                            product_name: cheonilData.product_name,
                            product_code: orderItem.productCode,
                            description: cheonilData.description,
                            courier_fee: cheonilData.courier_fee,
                            ship_comp: '\uCC9C\uC77C'
                        },
                        wbl_num: normalizedTrackingNo,
                        quantityIndex: orderItem.quantityIndex + i,
                        boxIndex: orderItem.boxIndex + i,
                        // cleaned legacy comment
                        locationInfo: {
                            A: cheonilLocation.A || '',
                            B: cheonilLocation.B || '',
                            C: cheonilLocation.C || '',
                            locationSort: cheonilLocation.locationSort || `Z-Z-Z-${cheonilData.productCode || orderItem.productCode || ''}`
                        },
                        productCode: cheonilData.productCode,
                        cheonil_data: {
                            route_code: cheonilData.route_code,
                            area_code: cheonilData.area_code,
                            urgent: cheonilData.urgent,
                            delivery_type: cheonilData.delivery_type,
                            special_note: cheonilData.special_note,
                            sender_info: cheonilData.sender_info,
                            interf: cheonilInterf,
                            intern: cheonilIntern,
                            receiver_info: cheonilData.receiver_info,
                            package_info: cheonilData.package_info,
                            barcode_info: normalizedTrackingNo || cheonilData.barcode_info
                        }
                    };
                    wblDataList.push(wblData);
                }
                return wblDataList;
            }
            else {
                console.error('천일택배 API 응답 오류:', response.data);
                return [];
            }
        }
        catch (error) {
            console.error('천일택배 API 호출 오류:', error);
            return [];
        }
    };
    const extractCheonilResponseOrderNumber = useCallback((cheonilData) => {
        var _a, _b, _c;
        return String((cheonilData === null || cheonilData === void 0 ? void 0 : cheonilData.orderNumber) ||
            (cheonilData === null || cheonilData === void 0 ? void 0 : cheonilData.order_number) ||
            ((_a = cheonilData === null || cheonilData === void 0 ? void 0 : cheonilData.orderInfo) === null || _a === void 0 ? void 0 : _a.order_number) ||
            ((_c = (_b = cheonilData === null || cheonilData === void 0 ? void 0 : cheonilData.cheonil_data) === null || _b === void 0 ? void 0 : _b.interf) === null || _c === void 0 ? void 0 : _c.ordnum) ||
            '').trim();
    }, []);
    const fetchCheonilPrintRows = useCallback(async (orderNumbers) => {
        if (!Array.isArray(orderNumbers) || orderNumbers.length === 0) {
            return [];
        }
        const response = await axios.post(`${API_BASE_URL}/api/proxy/print-wbl-cheonil2`, {
            orderNumbers,
            is_reissue: isReissueMode
        });
        if (response.data.success && Array.isArray(response.data.data)) {
            return response.data.data;
        }
        console.error('천일택배 API 응답 오류:', response.data);
        return [];
    }, [isReissueMode]);
    const buildCheonilWaybillDataList = useCallback((orderItem, cheonilRows) => {
        var _a, _b, _c;
        const wblDataList = [];
        for (let i = 0; i < cheonilRows.length; i++) {
            const cheonilData = cheonilRows[i] || {};
            const cheonilLocation = cheonilData.locationInfo || {};
            const cheonilInterf = { ...(((_a = cheonilData.cheonil_data) === null || _a === void 0 ? void 0 : _a.interf) || {}) };
            const cheonilIntern = { ...(((_b = cheonilData.cheonil_data) === null || _b === void 0 ? void 0 : _b.intern) || {}) };
            const normalizedTrackingNo = String(cheonilIntern.asitnb ||
                cheonilInterf.mainnb ||
                cheonilData.wbl_num ||
                cheonilData.trackingNumber ||
                '').trim();
            if (normalizedTrackingNo) {
                cheonilIntern.asitnb = normalizedTrackingNo;
                cheonilIntern.mainnb = normalizedTrackingNo;
                cheonilInterf.mainnb = normalizedTrackingNo;
            }
            const wblData = {
                orderInfo: {
                    order_number: orderItem.orderNumber,
                    recipient_name: cheonilData.recipient_name,
                    address: cheonilData.address,
                    zip_code: cheonilData.zip_code,
                    mobile_phone: cheonilData.mobile_phone,
                    order_date: cheonilData.order_date,
                    quantity: cheonilData.quantity,
                    message: cheonilData.message || cheonilData.special_note || ((_c = orderItem.orderData) === null || _c === void 0 ? void 0 : _c.message) || '',
                    boxqty: 1,
                    ship_comp: '\uCC9C\uC77C'
                },
                orderNumber: orderItem.orderNumber,
                productInfo: {
                    product_name: cheonilData.product_name,
                    product_code: orderItem.productCode,
                    description: cheonilData.description,
                    courier_fee: cheonilData.courier_fee,
                    ship_comp: '\uCC9C\uC77C'
                },
                wbl_num: normalizedTrackingNo,
                quantityIndex: orderItem.quantityIndex + i,
                boxIndex: orderItem.boxIndex + i,
                locationInfo: {
                    A: cheonilLocation.A || '',
                    B: cheonilLocation.B || '',
                    C: cheonilLocation.C || '',
                    locationSort: cheonilLocation.locationSort || `Z-Z-Z-${cheonilData.productCode || orderItem.productCode || ''}`
                },
                productCode: cheonilData.productCode,
                cheonil_data: {
                    route_code: cheonilData.route_code,
                    area_code: cheonilData.area_code,
                    urgent: cheonilData.urgent,
                    delivery_type: cheonilData.delivery_type,
                    special_note: cheonilData.special_note,
                    sender_info: cheonilData.sender_info,
                    interf: cheonilInterf,
                    intern: cheonilIntern,
                    receiver_info: cheonilData.receiver_info,
                    package_info: cheonilData.package_info,
                    barcode_info: normalizedTrackingNo || cheonilData.barcode_info
                }
            };
            wblDataList.push(wblData);
        }
        return wblDataList;
    }, []);
    const prefetchCheonilWaybills = useCallback(async (orderItems) => {
        const cheonilMap = new Map();
        const rawOrderNumbers = (orderItems || [])
            .map((item) => String((item === null || item === void 0 ? void 0 : item.orderNumber) || '').trim())
            .filter(Boolean);
        const uniqueOrderNumbers = rawOrderNumbers.filter((value, index, array) => array.indexOf(value) === index);
        for (const batchOrderNumbers of chunkArray(uniqueOrderNumbers, CHEONIL_PRINT_BATCH_SIZE)) {
            try {
                const cheonilRows = await fetchCheonilPrintRows(batchOrderNumbers);
                cheonilRows.forEach((cheonilRow) => {
                    const orderNumber = extractCheonilResponseOrderNumber(cheonilRow);
                    if (!orderNumber) {
                        return;
                    }
                    const existingRows = cheonilMap.get(orderNumber) || [];
                    existingRows.push(cheonilRow);
                    cheonilMap.set(orderNumber, existingRows);
                });
            }
            catch (error) {
                console.error(`천일 출력 배치 조회 실패 (${batchOrderNumbers.join(', ')}):`, error);
            }
        }
        return cheonilMap;
    }, [extractCheonilResponseOrderNumber, fetchCheonilPrintRows]);
    const createCheonilWblDataFromBatch = useCallback(async (orderItem, prefetchedRows) => {
        try {
            const cheonilRows = Array.isArray(prefetchedRows) && prefetchedRows.length > 0
                ? prefetchedRows
                : await fetchCheonilPrintRows([orderItem.orderNumber]);
            if (cheonilRows.length > 0) {
                return buildCheonilWaybillDataList(orderItem, cheonilRows);
            }
            if (!prefetchedRows) {
                return [];
            }
            const retryRows = await fetchCheonilPrintRows([orderItem.orderNumber]);
            return retryRows.length > 0 ? buildCheonilWaybillDataList(orderItem, retryRows) : [];
        }
        catch (error) {
            console.error('천일 배치 운송장 생성 오류:', error);
            return [];
        }
    }, [buildCheonilWaybillDataList, fetchCheonilPrintRows]);
    // cleaned legacy comment
    const sendToCourier = async (wblData) => {
        var _a, _b, _c;
        const courierType = getCourierType(((_a = wblData.productInfo) === null || _a === void 0 ? void 0 : _a.ship_comp) || ((_b = wblData.orderInfo) === null || _b === void 0 ? void 0 : _b.ship_comp) || '');
        switch (courierType) {
            case 'hanjin':
                return await sendToHanjin(wblData);
            case 'kyungdong':
                // cleaned legacy comment
                return { success: true, message: '경동택배 처리 완료' };
            case 'cheonil':
                // cleaned legacy comment
                return { success: true, message: '천일택배 처리 완료' };
            default:
                console.warn(`알 수 없는 택배사 ${(_c = wblData.productInfo) === null || _c === void 0 ? void 0 : _c.ship_comp}, 한진택배로 처리합니다.`);
                return await sendToHanjin(wblData);
        }
    };
    useEffect(() => {
        // 以묐났 ?ㅽ뻾 諛⑹?
        if (isInitialized.current)
            return;
        isInitialized.current = true;
        const processOrders = async () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18;
            try {
                const queryOrderNumbers = (searchParams.get('order_numbers') || '')
                    .split(',')
                    .map((value) => decodeURIComponent(value).trim())
                    .filter(Boolean);
                // cleaned legacy comment
                let orderNumbers = [];
                if (queryOrderNumbers.length > 0) {
                    orderNumbers = queryOrderNumbers;
                }
                else {
                    try {
                        const printOrdersResult = await getPrintOrders();
                        orderNumbers = printOrdersResult.data || [];
                    }
                    catch (error) {
                        console.error('주문번호 조회 실패:', error);
                        alert('주문번호를 조회할 수 없습니다.');
                        return;
                    }
                }
                if (orderNumbers.length === 0) {
                    alert('처리할 주문이 없습니다.');
                    return;
                }
                // cleaned legacy comment
                let orderWithLocationList = [];
                try {
                    const ordersResult = await getOrdersByNumbers(orderNumbers);
                    const ordersData = ordersResult.data || [];
                    if (ordersData.length === 0) {
                        setError('출력 대상 주문을 찾지 못했습니다. 선택한 주문의 상세 데이터가 조회되지 않습니다.');
                        setLoading(false);
                        return;
                    }
                    // cleaned legacy comment
                    orderWithLocationList = await Promise.all(ordersData.map(async (orderData) => {
                        let locationInfo = null;
                        let locationSort = `Z-Z-Z-${orderData.product_code || 'UNKNOWN'}`;
                        let productName = orderData.product_name; // 기본값으로 주문 상품명 사용
                        // 상품명이 비어있을 때만 상품 마스터명을 fallback으로 조회한다.
                        if (orderData.product_code && !String(productName || '').trim()) {
                            try {
                                const productResponse = await axios.get(`${API_BASE_URL}/api/products/product/${orderData.product_code}`);
                                if (productResponse.data && productResponse.data.product_name) {
                                    productName = productResponse.data.product_name;
                                }
                                else {
                                    console.warn(`상품 ${orderData.product_code}의 정보를 찾을 수 없음, 기본값 사용: ${productName}`);
                                }
                            }
                            catch (error) {
                                console.warn(`상품 정보 조회 실패 (상품코드: ${orderData.product_code}):`, error);
                            }
                        }
                        // cleaned legacy comment
                        if (orderData.gift_product_name) {
                            productName = `${productName} + ${orderData.gift_product_name}`;
                        }
                        // cleaned legacy comment
                        if (orderData.product_code) {
                            try {
                                const locationResponse = await axios.post(`${API_BASE_URL}/api/locations/available`, {
                                    product_code: orderData.product_code
                                });
                                if (locationResponse.data && locationResponse.data.length > 0) {
                                    const location = locationResponse.data[0];
                                    locationInfo = {
                                        A: location.A,
                                        B: location.B,
                                        C: location.C,
                                        locationSort: `${location.A}-${location.B}-${location.C}-${orderData.product_code}`
                                    };
                                    locationSort = locationInfo.locationSort;
                                }
                                else {
                                    console.warn(`상품 ${orderData.product_code}의 로케이션 정보를 찾을 수 없음`);
                                    // cleaned legacy comment
                                    locationSort = `Z-Z-Z-${orderData.product_code}`;
                                }
                            }
                            catch (error) {
                                console.warn(`로케이션 조회 실패 (상품코드: ${orderData.product_code}):`, error);
                                // cleaned legacy comment
                                locationSort = `Z-Z-Z-${orderData.product_code}`;
                            }
                        }
                        return {
                            orderNumber: orderData.order_number,
                            orderSeq: orderData.id,
                            orderData: orderData,
                            productCode: orderData.product_code,
                            productData: {
                                product_name: productName,
                                product_code: orderData.product_code
                            },
                            locationInfo: locationInfo,
                            locationSort: locationSort,
                            quantityIndex: 0,
                            boxIndex: 0
                        };
                    }));
                }
                catch (error) {
                    console.error('주문 정보 조회 실패:', error);
                    alert('주문 정보를 조회할 수 없습니다.');
                    return;
                }
                if (orderWithLocationList.length === 0) {
                    alert('유효한 주문 정보를 찾을 수 없습니다.');
                    return;
                }
                setLoading(true);
                setError(null);
                const cheonilOrderItems = orderWithLocationList.filter((item) => { var _a; return getCourierType(((_a = item.orderData) === null || _a === void 0 ? void 0 : _a.ship_comp) || '') === 'cheonil'; });
                const cheonilWaybillMap = cheonilOrderItems.length > 1
                    ? await prefetchCheonilWaybills(cheonilOrderItems)
                    : new Map();
                // cleaned legacy comment
                orderWithLocationList.sort((a, b) => {
                    const aSort = a.locationSort || `Z-Z-Z-${a.productCode || 'UNKNOWN'}`;
                    const bSort = b.locationSort || `Z-Z-Z-${b.productCode || 'UNKNOWN'}`;
                    return aSort.localeCompare(bSort);
                });
                orderWithLocationList.forEach((orderItem, index) => {
                });
                // cleaned legacy comment
                const wblList = [];
                const processingErrors = [];
                // cleaned legacy comment
                for (let index = 0; index < orderWithLocationList.length; index++) {
                    const orderItem = orderWithLocationList[index];
                    try {
                        let wblData = null;
                        // cleaned legacy comment
                        const courierType = getCourierType(orderItem.orderData.ship_comp || '');
                        if (courierType === 'hanjin') {
                            const hanjinPrintTargets = await buildHanjinPrintTargets(orderItem);
                            const totalLabelCount = hanjinPrintTargets.length;
                            const hanjinWblDataList = [];
                            let firstHanjinRoutingMeta = null;
                            for (let labelOffset = 0; labelOffset < totalLabelCount; labelOffset++) {
                                const printTarget = hanjinPrintTargets[labelOffset] || {};
                                const seqEntry = printTarget.seqEntry || null;
                                const quantityIndex = 0;
                                const boxIndex = labelOffset;
                                const labelSequence = Number(printTarget.labelSequence || (labelOffset + 1)) || (labelOffset + 1);
                                const shipOrderId = String(printTarget.shipOrderId ||
                                    (seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.ship_order_id) ||
                                    `${orderItem.orderNumber}-${String(labelSequence).padStart(2, '0')}`).trim();
                                const targetTrackingNo = String(printTarget.trackingNo || (seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.tracking_no) || '').trim();
                                const targetLocationInfo = printTarget.locationInfo || orderItem.locationInfo;
                                const targetProductName = String((seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.product_name) ||
                                    ((_a = orderItem === null || orderItem === void 0 ? void 0 : orderItem.productData) === null || _a === void 0 ? void 0 : _a.product_name) ||
                                    ((_b = orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderData) === null || _b === void 0 ? void 0 : _b.product_name) ||
                                    '').trim();
                                const targetProductCode = String((seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.product_code) ||
                                    ((_c = orderItem === null || orderItem === void 0 ? void 0 : orderItem.productData) === null || _c === void 0 ? void 0 : _c.product_code) ||
                                    ((_d = orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderData) === null || _d === void 0 ? void 0 : _d.product_code) ||
                                    '').trim();
                                const targetOrderInfo = {
                                    ...(orderItem.orderData || {}),
                                    quantity: Number((_g = (_e = seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.quantity) !== null && _e !== void 0 ? _e : (_f = orderItem.orderData) === null || _f === void 0 ? void 0 : _f.quantity) !== null && _g !== void 0 ? _g : 1) || 1,
                                    tracking_number: targetTrackingNo || ((_h = orderItem.orderData) === null || _h === void 0 ? void 0 : _h.tracking_number) || ''
                                };
                                const targetProductInfo = {
                                    ...(orderItem.productData || {}),
                                    product_name: targetProductName,
                                    product_code: targetProductCode
                                };
                                if (isReissueMode) {
                                    const reissuePayload = {
                                        wbl_num: targetTrackingNo,
                                        orderInfo: targetOrderInfo,
                                        orderNumber: orderItem.orderNumber,
                                        ship_order_id: shipOrderId,
                                        productInfo: targetProductInfo,
                                        quantityIndex,
                                        boxIndex: boxIndex + 1,
                                        labelSequence,
                                        locationInfo: targetLocationInfo,
                                        productCode: targetProductCode || orderItem.productCode,
                                        courier_type: 'hanjin'
                                    };
                                    const reissuedHanjin = await sendToHanjin(reissuePayload);
                                    const reissuedHanjinWblData = buildIssuedHanjinWaybillData(reissuePayload, boxIndex, totalLabelCount, reissuedHanjin, firstHanjinRoutingMeta);
                                    if (reissuedHanjin.success && reissuedHanjinWblData) {
                                        firstHanjinRoutingMeta = firstHanjinRoutingMeta || reissuedHanjinWblData;
                                        hanjinWblDataList.push(mergeHanjinRoutingMeta(reissuedHanjinWblData, firstHanjinRoutingMeta));
                                        continue;
                                    }
                                    throw new Error(`한진 재발행 실패 (${orderItem.orderNumber} / ${boxIndex + 1}/${totalLabelCount}): ${reissuedHanjin.message || '새 송장 발급 실패'}`);
                                }
                                let hanjinPrintData = {};
                                try {
                                    const hanjinResponse = await axios.post(`${API_BASE_URL}/api/proxy/print-wbl`, {
                                        order_number: orderItem.orderNumber,
                                        address: targetOrderInfo.address,
                                        zip_code: targetOrderInfo.zip_code,
                                        ship_order_id: shipOrderId,
                                        box_index: boxIndex + 1,
                                    });
                                    hanjinPrintData = hanjinResponse.data || {};
                                }
                                catch (apiError) {
                                    const fallbackHanjin = buildFallbackWaybillFromOrder({
                                        ...orderItem,
                                        orderData: targetOrderInfo,
                                        productData: targetProductInfo,
                                        boxIndex: boxIndex + 1,
                                        quantityIndex,
                                        labelSequence,
                                        locationInfo: targetLocationInfo,
                                        productCode: targetProductCode || orderItem.productCode
                                    }, 'hanjin', '한진 응답 없음 - 기존 tracking 사용', targetTrackingNo);
                                    if (fallbackHanjin) {
                                        firstHanjinRoutingMeta = firstHanjinRoutingMeta || fallbackHanjin;
                                        const normalizedFallback = mergeHanjinRoutingMeta(fallbackHanjin, firstHanjinRoutingMeta);
                                        normalizedFallback.sequenceNumber = index + 1 + labelOffset;
                                        normalizedFallback.totalCount = totalLabelCount;
                                        normalizedFallback.boxIndex = boxIndex + 1;
                                        normalizedFallback.quantityIndex = quantityIndex;
                                        normalizedFallback.labelSequence = labelSequence;
                                        hanjinWblDataList.push(normalizedFallback);
                                        processingErrors.push(`한진 응답 없음 (${orderItem.orderNumber} / ${boxIndex + 1}/${totalLabelCount}) - 기존 tracking 으로 대체`);
                                        continue;
                                    }
                                    const issuedHanjin = await sendToHanjin({
                                        wbl_num: '',
                                        orderInfo: targetOrderInfo,
                                        orderNumber: orderItem.orderNumber,
                                        productInfo: targetProductInfo,
                                        quantityIndex,
                                        boxIndex: boxIndex + 1,
                                        labelSequence,
                                        locationInfo: targetLocationInfo,
                                        productCode: targetProductCode || orderItem.productCode,
                                        courier_type: 'hanjin'
                                    });
                                    const issuedHanjinWblData = buildIssuedHanjinWaybillData({
                                        ...orderItem,
                                        orderData: targetOrderInfo,
                                        productData: targetProductInfo,
                                        ship_order_id: shipOrderId,
                                        quantityIndex,
                                        boxIndex: boxIndex + 1,
                                        labelSequence,
                                        locationInfo: targetLocationInfo,
                                        productCode: targetProductCode || orderItem.productCode
                                    }, boxIndex, totalLabelCount, issuedHanjin, firstHanjinRoutingMeta);
                                    if (issuedHanjin.success && issuedHanjinWblData) {
                                        firstHanjinRoutingMeta = firstHanjinRoutingMeta || issuedHanjinWblData;
                                        hanjinWblDataList.push(mergeHanjinRoutingMeta(issuedHanjinWblData, firstHanjinRoutingMeta));
                                        processingErrors.push(`한진 응답 없음 (${orderItem.orderNumber} / ${boxIndex + 1}/${totalLabelCount}) - insert-order 로 대체`);
                                        continue;
                                    }
                                    const apiMessage = ((_k = (_j = apiError === null || apiError === void 0 ? void 0 : apiError.response) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.message) || ((_o = (_m = (_l = apiError === null || apiError === void 0 ? void 0 : apiError.response) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.hanjinError) === null || _o === void 0 ? void 0 : _o.message) || (apiError === null || apiError === void 0 ? void 0 : apiError.message) || '한진 송장 생성 실패';
                                    throw new Error(`한진 송장 생성 실패 (${orderItem.orderNumber} / ${boxIndex + 1}/${totalLabelCount}): ${apiMessage}`);
                                }
                                if (!String((hanjinPrintData === null || hanjinPrintData === void 0 ? void 0 : hanjinPrintData.wbl_num) || (hanjinPrintData === null || hanjinPrintData === void 0 ? void 0 : hanjinPrintData.wblNo) || (hanjinPrintData === null || hanjinPrintData === void 0 ? void 0 : hanjinPrintData.wblNoNo) || '').trim()) {
                                    const fallbackHanjin = buildFallbackWaybillFromOrder({
                                        ...orderItem,
                                        orderData: targetOrderInfo,
                                        productData: targetProductInfo,
                                        boxIndex: boxIndex + 1,
                                        quantityIndex,
                                        labelSequence,
                                        locationInfo: targetLocationInfo,
                                        productCode: targetProductCode || orderItem.productCode
                                    }, 'hanjin', '한진 응답 비어있음 - 기존 tracking 사용', targetTrackingNo);
                                    if (fallbackHanjin) {
                                        firstHanjinRoutingMeta = firstHanjinRoutingMeta || fallbackHanjin;
                                        const normalizedFallback = mergeHanjinRoutingMeta(fallbackHanjin, firstHanjinRoutingMeta);
                                        normalizedFallback.sequenceNumber = index + 1 + labelOffset;
                                        normalizedFallback.totalCount = totalLabelCount;
                                        normalizedFallback.boxIndex = boxIndex + 1;
                                        normalizedFallback.quantityIndex = quantityIndex;
                                        normalizedFallback.labelSequence = labelSequence;
                                        hanjinWblDataList.push(normalizedFallback);
                                        processingErrors.push(`한진 응답 비어있음 (${orderItem.orderNumber} / ${boxIndex + 1}/${totalLabelCount}) - 기존 tracking 으로 대체`);
                                        continue;
                                    }
                                    const issuedHanjin = await sendToHanjin({
                                        wbl_num: '',
                                        orderInfo: targetOrderInfo,
                                        orderNumber: orderItem.orderNumber,
                                        productInfo: targetProductInfo,
                                        quantityIndex,
                                        boxIndex: boxIndex + 1,
                                        labelSequence,
                                        locationInfo: targetLocationInfo,
                                        productCode: targetProductCode || orderItem.productCode,
                                        courier_type: 'hanjin'
                                    });
                                    const issuedHanjinWblData = buildIssuedHanjinWaybillData({
                                        ...orderItem,
                                        orderData: targetOrderInfo,
                                        productData: targetProductInfo,
                                        ship_order_id: shipOrderId,
                                        quantityIndex,
                                        boxIndex: boxIndex + 1,
                                        labelSequence,
                                        locationInfo: targetLocationInfo,
                                        productCode: targetProductCode || orderItem.productCode
                                    }, boxIndex, totalLabelCount, issuedHanjin, firstHanjinRoutingMeta);
                                    if (issuedHanjin.success && issuedHanjinWblData) {
                                        firstHanjinRoutingMeta = firstHanjinRoutingMeta || issuedHanjinWblData;
                                        hanjinWblDataList.push(mergeHanjinRoutingMeta(issuedHanjinWblData, firstHanjinRoutingMeta));
                                        processingErrors.push(`한진 응답 비어있음 (${orderItem.orderNumber} / ${boxIndex + 1}/${totalLabelCount}) - insert-order 로 대체`);
                                        continue;
                                    }
                                }
                                let hanjinWblData = {
                                    ...hanjinPrintData,
                                    wbl_num: hanjinPrintData.wbl_num || hanjinPrintData.wblNo || hanjinPrintData.wblNoNo || targetTrackingNo || '',
                                    sequenceNumber: index + 1 + labelOffset,
                                    totalCount: totalLabelCount,
                                    quantityIndex,
                                    boxIndex: boxIndex + 1,
                                    labelSequence,
                                    boxType: hanjinPrintData.boxtype,
                                    orderInfo: targetOrderInfo,
                                    orderNumber: orderItem.orderNumber,
                                    productInfo: {
                                        ...targetProductInfo,
                                        product_name: String((hanjinPrintData === null || hanjinPrintData === void 0 ? void 0 : hanjinPrintData.product_name) || '').trim() || targetProductName || '',
                                        product_code: String((hanjinPrintData === null || hanjinPrintData === void 0 ? void 0 : hanjinPrintData.product_code) || '').trim() || targetProductCode || ''
                                    },
                                    locationInfo: targetLocationInfo,
                                    productCode: targetProductCode || orderItem.productCode,
                                    ship_order_id: shipOrderId,
                                    courier_type: 'hanjin'
                                };
                                firstHanjinRoutingMeta = firstHanjinRoutingMeta || hanjinWblData;
                                hanjinWblData = mergeHanjinRoutingMeta(hanjinWblData, firstHanjinRoutingMeta);
                                const hanjinResult = await sendToHanjin(hanjinWblData);
                                hanjinWblData = {
                                    ...hanjinWblData,
                                    ...((hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.data) || {}),
                                    productInfo: {
                                        ...(hanjinWblData.productInfo || {}),
                                        product_name: String(((_p = hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.data) === null || _p === void 0 ? void 0 : _p.product_name) || '').trim() ||
                                            String(((_q = hanjinWblData === null || hanjinWblData === void 0 ? void 0 : hanjinWblData.productInfo) === null || _q === void 0 ? void 0 : _q.product_name) || '').trim() ||
                                            '',
                                        product_code: String(((_r = hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.data) === null || _r === void 0 ? void 0 : _r.product_code) || '').trim() ||
                                            String(((_s = hanjinWblData === null || hanjinWblData === void 0 ? void 0 : hanjinWblData.productInfo) === null || _s === void 0 ? void 0 : _s.product_code) || '').trim() ||
                                            ''
                                    },
                                    office_code: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.office_code) || hanjinWblData.office_code,
                                    office_name: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.office_name) || hanjinWblData.office_name,
                                    s_tml_cod: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.s_tml_cod) || hanjinWblData.s_tml_cod,
                                    s_tml_nam: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.s_tml_nam) || hanjinWblData.s_tml_nam,
                                    cen_cod: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.cen_cod) || hanjinWblData.cen_cod,
                                    cen_nam: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.cen_nam) || hanjinWblData.cen_nam,
                                    hub_cod: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.hub_cod) || hanjinWblData.hub_cod,
                                    tml_cod: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.tml_cod) || hanjinWblData.tml_cod,
                                    dom_mid: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.dom_mid) || hanjinWblData.dom_mid,
                                    dom_rgn: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.dom_rgn) || hanjinWblData.dom_rgn
                                };
                                hanjinWblData.boxType = hanjinResult.boxtype;
                                if (!hanjinResult.success) {
                                    processingErrors.push(`한진 전송 실패 (${orderItem.orderNumber} / ${boxIndex + 1}/${totalLabelCount}): ${hanjinResult.message || '전송 실패'}`);
                                }
                                if (hanjinResult.success) {
                                    const issuedTrackingNo = String((hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.wbl_num) ||
                                        (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.wblNo) ||
                                        '').trim();
                                    if (issuedTrackingNo) {
                                        hanjinWblData.wbl_num = issuedTrackingNo;
                                        hanjinWblData.wblNo = issuedTrackingNo;
                                    }
                                    firstHanjinRoutingMeta = firstHanjinRoutingMeta || hanjinWblData;
                                    hanjinWblData = mergeHanjinRoutingMeta(hanjinWblData, firstHanjinRoutingMeta);
                                    hanjinWblDataList.push(hanjinWblData);
                                }
                                if (labelOffset < totalLabelCount - 1) {
                                    await new Promise(resolve => setTimeout(resolve, 300));
                                }
                            }
                            const normalizedHanjinWblDataList = backfillHanjinOfficeInfo(hanjinWblDataList);
                            if (normalizedHanjinWblDataList.length === 0) {
                                processingErrors.push(`한진 운송장 데이터 없음 (${orderItem.orderNumber})`);
                            }
                            wblList.push(...normalizedHanjinWblDataList);
                            continue;
                        }
                        // cleaned legacy comment
                        switch (courierType) {
                            case 'hanjin':
                                // cleaned legacy comment
                                // quantity * box_qty 만큼 송장을 생성한다.
                                const boxQty = Math.max(1, Number((_x = (_w = (_u = (_t = orderItem.orderData) === null || _t === void 0 ? void 0 : _t.box_qty) !== null && _u !== void 0 ? _u : (_v = orderItem.orderData) === null || _v === void 0 ? void 0 : _v.boxQty) !== null && _w !== void 0 ? _w : orderItem.boxQty) !== null && _x !== void 0 ? _x : 1) || 1);
                                const totalLabelCount = boxQty;
                                const hanjinWblDataList = [];
                                let firstHanjinRoutingMeta = null;
                                for (let labelOffset = 0; labelOffset < totalLabelCount; labelOffset++) {
                                    const quantityIndex = 0;
                                    const boxIndex = labelOffset;
                                    const labelSequence = labelOffset + 1;
                                    const shipOrderId = `${orderItem.orderNumber}-${String(labelSequence).padStart(2, '0')}`;
                                    if (isReissueMode) {
                                        const reissuePayload = {
                                            wbl_num: '',
                                            orderInfo: orderItem.orderData,
                                            orderNumber: orderItem.orderNumber,
                                            ship_order_id: shipOrderId,
                                            productInfo: orderItem.productData,
                                            quantityIndex,
                                            boxIndex: boxIndex + 1,
                                            labelSequence,
                                            locationInfo: orderItem.locationInfo,
                                            productCode: orderItem.productCode,
                                            courier_type: 'hanjin'
                                        };
                                        const reissuedHanjin = await sendToHanjin(reissuePayload);
                                        const reissuedHanjinWblData = buildIssuedHanjinWaybillData(reissuePayload, boxIndex, orderWithLocationList.length, reissuedHanjin, firstHanjinRoutingMeta);
                                        if (reissuedHanjin.success && reissuedHanjinWblData) {
                                            firstHanjinRoutingMeta = firstHanjinRoutingMeta || reissuedHanjinWblData;
                                            hanjinWblDataList.push(mergeHanjinRoutingMeta(reissuedHanjinWblData, firstHanjinRoutingMeta));
                                            continue;
                                        }
                                        throw new Error(`한진 재발행 실패 (${orderItem.orderNumber} / ${boxIndex + 1}/${boxQty}): ${reissuedHanjin.message || '새 송장 발급 실패'}`);
                                    }
                                    let hanjinPrintData = {};
                                    try {
                                        const hanjinResponse = await axios.post(`${API_BASE_URL}/api/proxy/print-wbl`, {
                                            order_number: orderItem.orderNumber,
                                            address: orderItem.orderData.address,
                                            zip_code: orderItem.orderData.zip_code,
                                            ship_order_id: shipOrderId,
                                            box_index: boxIndex + 1,
                                        });
                                        hanjinPrintData = hanjinResponse.data || {};
                                    }
                                    catch (apiError) {
                                        const fallbackHanjin = buildFallbackWaybillFromOrder({
                                            ...orderItem,
                                            boxIndex: boxIndex + 1,
                                            quantityIndex,
                                            labelSequence
                                        }, 'hanjin', '한진 응답 없음 - 기존 tracking 사용');
                                        if (fallbackHanjin) {
                                            firstHanjinRoutingMeta = firstHanjinRoutingMeta || fallbackHanjin;
                                            const normalizedFallback = mergeHanjinRoutingMeta(fallbackHanjin, firstHanjinRoutingMeta);
                                            normalizedFallback.sequenceNumber = index + 1 + labelOffset;
                                            normalizedFallback.totalCount = orderWithLocationList.length;
                                            normalizedFallback.boxIndex = boxIndex + 1;
                                            normalizedFallback.quantityIndex = quantityIndex;
                                            normalizedFallback.labelSequence = labelSequence;
                                            hanjinWblDataList.push(normalizedFallback);
                                            processingErrors.push(`한진 응답 없음 (${orderItem.orderNumber} / ${boxIndex + 1}/${boxQty}) - 기존 tracking 으로 대체`);
                                            continue;
                                        }
                                        const issuedHanjin = await sendToHanjin({
                                            wbl_num: '',
                                            orderInfo: orderItem.orderData,
                                            orderNumber: orderItem.orderNumber,
                                            productInfo: orderItem.productData,
                                            quantityIndex,
                                            boxIndex: boxIndex + 1,
                                            labelSequence,
                                            locationInfo: orderItem.locationInfo,
                                            productCode: orderItem.productCode,
                                            courier_type: 'hanjin'
                                        });
                                        const issuedHanjinWblData = buildIssuedHanjinWaybillData({
                                            ...orderItem,
                                            ship_order_id: shipOrderId,
                                            quantityIndex,
                                            boxIndex: boxIndex + 1,
                                            labelSequence
                                        }, boxIndex, orderWithLocationList.length, issuedHanjin, firstHanjinRoutingMeta);
                                        if (issuedHanjin.success && issuedHanjinWblData) {
                                            firstHanjinRoutingMeta = firstHanjinRoutingMeta || issuedHanjinWblData;
                                            hanjinWblDataList.push(mergeHanjinRoutingMeta(issuedHanjinWblData, firstHanjinRoutingMeta));
                                            processingErrors.push(`한진 응답 없음 (${orderItem.orderNumber} / ${boxIndex + 1}/${boxQty}) - insert-order 로 대체`);
                                            continue;
                                        }
                                        const apiMessage = ((_z = (_y = apiError === null || apiError === void 0 ? void 0 : apiError.response) === null || _y === void 0 ? void 0 : _y.data) === null || _z === void 0 ? void 0 : _z.message) || ((_2 = (_1 = (_0 = apiError === null || apiError === void 0 ? void 0 : apiError.response) === null || _0 === void 0 ? void 0 : _0.data) === null || _1 === void 0 ? void 0 : _1.hanjinError) === null || _2 === void 0 ? void 0 : _2.message) || (apiError === null || apiError === void 0 ? void 0 : apiError.message) || '한진 송장 생성 실패';
                                        throw new Error(`한진 송장 생성 실패 (${orderItem.orderNumber} / ${boxIndex + 1}/${boxQty}): ${apiMessage}`);
                                    }
                                    if (!String((hanjinPrintData === null || hanjinPrintData === void 0 ? void 0 : hanjinPrintData.wbl_num) || (hanjinPrintData === null || hanjinPrintData === void 0 ? void 0 : hanjinPrintData.wblNo) || (hanjinPrintData === null || hanjinPrintData === void 0 ? void 0 : hanjinPrintData.wblNoNo) || '').trim()) {
                                        const fallbackHanjin = buildFallbackWaybillFromOrder({
                                            ...orderItem,
                                            boxIndex: boxIndex + 1,
                                            quantityIndex,
                                            labelSequence
                                        }, 'hanjin', '한진 응답 비어있음 - 기존 tracking 사용');
                                        if (fallbackHanjin) {
                                            firstHanjinRoutingMeta = firstHanjinRoutingMeta || fallbackHanjin;
                                            const normalizedFallback = mergeHanjinRoutingMeta(fallbackHanjin, firstHanjinRoutingMeta);
                                            normalizedFallback.sequenceNumber = index + 1 + labelOffset;
                                            normalizedFallback.totalCount = orderWithLocationList.length;
                                            normalizedFallback.boxIndex = boxIndex + 1;
                                            normalizedFallback.quantityIndex = quantityIndex;
                                            normalizedFallback.labelSequence = labelSequence;
                                            hanjinWblDataList.push(normalizedFallback);
                                            processingErrors.push(`한진 응답 비어있음 (${orderItem.orderNumber} / ${boxIndex + 1}/${boxQty}) - 기존 tracking 으로 대체`);
                                            continue;
                                        }
                                        const issuedHanjin = await sendToHanjin({
                                            wbl_num: '',
                                            orderInfo: orderItem.orderData,
                                            orderNumber: orderItem.orderNumber,
                                            productInfo: orderItem.productData,
                                            quantityIndex,
                                            boxIndex: boxIndex + 1,
                                            labelSequence,
                                            locationInfo: orderItem.locationInfo,
                                            productCode: orderItem.productCode,
                                            courier_type: 'hanjin'
                                        });
                                        const issuedHanjinWblData = buildIssuedHanjinWaybillData({
                                            ...orderItem,
                                            ship_order_id: shipOrderId,
                                            quantityIndex,
                                            boxIndex: boxIndex + 1,
                                            labelSequence
                                        }, boxIndex, orderWithLocationList.length, issuedHanjin, firstHanjinRoutingMeta);
                                        if (issuedHanjin.success && issuedHanjinWblData) {
                                            firstHanjinRoutingMeta = firstHanjinRoutingMeta || issuedHanjinWblData;
                                            hanjinWblDataList.push(mergeHanjinRoutingMeta(issuedHanjinWblData, firstHanjinRoutingMeta));
                                            processingErrors.push(`한진 응답 비어있음 (${orderItem.orderNumber} / ${boxIndex + 1}/${boxQty}) - insert-order 로 대체`);
                                            continue;
                                        }
                                    }
                                    let hanjinWblData = {
                                        ...hanjinPrintData,
                                        wbl_num: hanjinPrintData.wbl_num || hanjinPrintData.wblNo || hanjinPrintData.wblNoNo || '',
                                        sequenceNumber: index + 1 + labelOffset,
                                        totalCount: orderWithLocationList.length,
                                        quantityIndex,
                                        boxIndex: boxIndex + 1,
                                        labelSequence,
                                        boxType: hanjinPrintData.boxtype,
                                        orderInfo: orderItem.orderData,
                                        orderNumber: orderItem.orderNumber,
                                        productInfo: {
                                            ...(orderItem.productData || {}),
                                            product_name: String((hanjinPrintData === null || hanjinPrintData === void 0 ? void 0 : hanjinPrintData.product_name) || '').trim() ||
                                                String(((_3 = orderItem === null || orderItem === void 0 ? void 0 : orderItem.productData) === null || _3 === void 0 ? void 0 : _3.product_name) || '').trim() ||
                                                String(((_4 = orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderData) === null || _4 === void 0 ? void 0 : _4.product_name) || '').trim() ||
                                                '',
                                            product_code: String((hanjinPrintData === null || hanjinPrintData === void 0 ? void 0 : hanjinPrintData.product_code) || '').trim() ||
                                                String(((_5 = orderItem === null || orderItem === void 0 ? void 0 : orderItem.productData) === null || _5 === void 0 ? void 0 : _5.product_code) || '').trim() ||
                                                String(((_6 = orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderData) === null || _6 === void 0 ? void 0 : _6.product_code) || '').trim() ||
                                                ''
                                        },
                                        locationInfo: orderItem.locationInfo,
                                        productCode: orderItem.productCode,
                                        ship_order_id: shipOrderId,
                                        courier_type: 'hanjin'
                                    };
                                    firstHanjinRoutingMeta = firstHanjinRoutingMeta || hanjinWblData;
                                    hanjinWblData = mergeHanjinRoutingMeta(hanjinWblData, firstHanjinRoutingMeta);
                                    const hanjinResult = await sendToHanjin(hanjinWblData);
                                    hanjinWblData = {
                                        ...hanjinWblData,
                                        ...((hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.data) || {}),
                                        productInfo: {
                                            ...(hanjinWblData.productInfo || {}),
                                            product_name: String(((_7 = hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.data) === null || _7 === void 0 ? void 0 : _7.product_name) || '').trim() ||
                                                String(((_8 = hanjinWblData === null || hanjinWblData === void 0 ? void 0 : hanjinWblData.productInfo) === null || _8 === void 0 ? void 0 : _8.product_name) || '').trim() ||
                                                '',
                                            product_code: String(((_9 = hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.data) === null || _9 === void 0 ? void 0 : _9.product_code) || '').trim() ||
                                                String(((_10 = hanjinWblData === null || hanjinWblData === void 0 ? void 0 : hanjinWblData.productInfo) === null || _10 === void 0 ? void 0 : _10.product_code) || '').trim() ||
                                                ''
                                        },
                                        office_code: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.office_code) || hanjinWblData.office_code,
                                        office_name: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.office_name) || hanjinWblData.office_name,
                                        s_tml_cod: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.s_tml_cod) || hanjinWblData.s_tml_cod,
                                        s_tml_nam: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.s_tml_nam) || hanjinWblData.s_tml_nam,
                                        cen_cod: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.cen_cod) || hanjinWblData.cen_cod,
                                        cen_nam: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.cen_nam) || hanjinWblData.cen_nam,
                                        hub_cod: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.hub_cod) || hanjinWblData.hub_cod,
                                        tml_cod: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.tml_cod) || hanjinWblData.tml_cod,
                                        dom_mid: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.dom_mid) || hanjinWblData.dom_mid,
                                        dom_rgn: (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.dom_rgn) || hanjinWblData.dom_rgn
                                    };
                                    hanjinWblData.boxType = hanjinResult.boxtype;
                                    if (!hanjinResult.success) {
                                        processingErrors.push(`한진 저장 실패 (${orderItem.orderNumber} / ${boxIndex + 1}/${boxQty}): ${hanjinResult.message || '저장 실패'}`);
                                    }
                                    if (hanjinResult.success) {
                                        const issuedTrackingNo = String((hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.wbl_num) ||
                                            (hanjinResult === null || hanjinResult === void 0 ? void 0 : hanjinResult.wblNo) ||
                                            '').trim();
                                        if (issuedTrackingNo) {
                                            hanjinWblData.wbl_num = issuedTrackingNo;
                                            hanjinWblData.wblNo = issuedTrackingNo;
                                        }
                                        firstHanjinRoutingMeta = firstHanjinRoutingMeta || hanjinWblData;
                                        hanjinWblData = mergeHanjinRoutingMeta(hanjinWblData, firstHanjinRoutingMeta);
                                        hanjinWblDataList.push(hanjinWblData);
                                    }
                                    if (labelOffset < totalLabelCount - 1) {
                                        await new Promise(resolve => setTimeout(resolve, 300));
                                    }
                                }
                                // cleaned legacy comment
                                const normalizedHanjinWblDataList = backfillHanjinOfficeInfo(hanjinWblDataList);
                                if (normalizedHanjinWblDataList.length === 0) {
                                    processingErrors.push(`한진 운송장 데이터 없음 (${orderItem.orderNumber})`);
                                }
                                wblList.push(...normalizedHanjinWblDataList);
                                // cleaned legacy comment
                                // wblData = hanjinWblDataList[0];
                                break;
                            case 'kyungdong':
                                // cleaned legacy comment
                                // cleaned legacy comment
                                {
                                    const kyungdongSeqEntries = await getOrderSeqEntries(orderItem.orderNumber);
                                    const effectiveKyungdongSeqEntries = kyungdongSeqEntries.length > 0
                                        ? kyungdongSeqEntries
                                        : [null];
                                    const kyungdongWblDataList = [];
                                    for (let seqIndex = 0; seqIndex < effectiveKyungdongSeqEntries.length; seqIndex++) {
                                        const seqEntry = effectiveKyungdongSeqEntries[seqIndex];
                                        const kyungdongWblData = await createKyungdongWblData({
                                            ...orderItem,
                                            orderNumber: (seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.order_number) || orderItem.orderNumber,
                                            quantityIndex: seqIndex + 1,
                                            boxIndex: seqIndex + 1,
                                            splitQuantity: Number((seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.quantity) || 1) || 1,
                                            displayQuantity: Number((seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.quantity) || 1) || 1,
                                            originalQuantity: Number((_14 = (_13 = (_11 = orderItem.originalQuantity) !== null && _11 !== void 0 ? _11 : (_12 = orderItem.orderData) === null || _12 === void 0 ? void 0 : _12.quantity) !== null && _13 !== void 0 ? _13 : seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.quantity) !== null && _14 !== void 0 ? _14 : 1) || 1,
                                            totalQuantity: Number((_18 = (_17 = (_15 = orderItem.totalQuantity) !== null && _15 !== void 0 ? _15 : (_16 = orderItem.orderData) === null || _16 === void 0 ? void 0 : _16.quantity) !== null && _17 !== void 0 ? _17 : seqEntry === null || seqEntry === void 0 ? void 0 : seqEntry.quantity) !== null && _18 !== void 0 ? _18 : 1) || 1,
                                            seqEntry
                                        });
                                        if (!kyungdongWblData) {
                                            continue;
                                        }
                                        const resolvedKyungdongWblData = kyungdongWblData;
                                        const locationResponse = await axios.post(`${API_BASE_URL}/api/locations/available`, {
                                            product_code: resolvedKyungdongWblData.productCode
                                        });
                                        const location = locationResponse.data[0];
                                        if (location) {
                                            resolvedKyungdongWblData.locationInfo = {
                                                A: location.A,
                                                B: location.B,
                                                C: location.C,
                                                locationSort: `${location.A}-${location.B}-${location.C}-${resolvedKyungdongWblData.productCode}`
                                            };
                                        }
                                        else {
                                            resolvedKyungdongWblData.locationInfo = {
                                                A: 'Z',
                                                B: 'Z',
                                                C: 'Z',
                                                locationSort: `Z-Z-Z-${resolvedKyungdongWblData.productCode}`
                                            };
                                        }
                                        resolvedKyungdongWblData.sequenceNumber = index + 1 + seqIndex;
                                        resolvedKyungdongWblData.totalCount = orderWithLocationList.length;
                                        resolvedKyungdongWblData.boxIndex = seqIndex + 1;
                                        resolvedKyungdongWblData.orderBoxTotal = effectiveKyungdongSeqEntries.length;
                                        resolvedKyungdongWblData.courier_type = 'kyungdong';
                                        kyungdongWblDataList.push(resolvedKyungdongWblData);
                                    }
                                    if (kyungdongWblDataList.length === 0) {
                                        console.error('경동택배 송장 생성 실패');
                                        continue;
                                    }
                                    wblList.push(...kyungdongWblDataList);
                                    break;
                                }
                                const kyungdongOriginalQuantity = Math.max(1, Number(orderItem.orderData.quantity) || 1);
                                const kyungdongBoxQty = Math.max(1, Number(orderItem.orderData.box_qty) || 1);
                                const totalQty = kyungdongOriginalQuantity * kyungdongBoxQty;
                                const kyungdongWblDataList = [];
                                for (let i = 0; i < totalQty; i++) {
                                    const splitQuantity = 1;
                                    const kyungdongOrderItem = {
                                        ...orderItem,
                                        orderNumber: `${orderItem.orderData.order_number}-${String(i + 1).padStart(2, '0')}`,
                                        quantityIndex: i + 1,
                                        boxIndex: (i % kyungdongBoxQty) + 1,
                                        splitQuantity,
                                        originalQuantity: kyungdongOriginalQuantity,
                                        boxQty: kyungdongBoxQty,
                                        totalQuantity: totalQty,
                                        displayQuantity: totalQty
                                    };
                                    const kyungdongWblData = await createKyungdongWblData(kyungdongOrderItem);
                                    if (kyungdongWblData) {
                                        // cleaned legacy comment
                                        const resolvedKyungdongWblData = kyungdongWblData;
                                        const locationResponse = await axios.post(`${API_BASE_URL}/api/locations/available`, {
                                            product_code: resolvedKyungdongWblData.productCode
                                        });
                                        const location = locationResponse.data[0];
                                        if (location) {
                                            resolvedKyungdongWblData.locationInfo = {
                                                A: location.A,
                                                B: location.B,
                                                C: location.C,
                                                locationSort: `${location.A}-${location.B}-${location.C}-${resolvedKyungdongWblData.productCode}`
                                            };
                                        }
                                        else {
                                            resolvedKyungdongWblData.locationInfo = {
                                                A: 'Z',
                                                B: 'Z',
                                                C: 'Z',
                                                locationSort: `Z-Z-Z-${resolvedKyungdongWblData.productCode}`
                                            };
                                        }
                                        resolvedKyungdongWblData.sequenceNumber = index + 1 + i;
                                        resolvedKyungdongWblData.totalCount = orderWithLocationList.length;
                                        resolvedKyungdongWblData.displayQuantity = totalQty;
                                        resolvedKyungdongWblData.splitQuantity = splitQuantity;
                                        resolvedKyungdongWblData.originalQuantity = kyungdongOriginalQuantity;
                                        resolvedKyungdongWblData.totalQuantity = totalQty;
                                        // kyungdongWblData.locationInfo = orderItem.locationInfo;
                                        // kyungdongWblData.productCode = orderItem.productCode;
                                        resolvedKyungdongWblData.courier_type = 'kyungdong';
                                        kyungdongWblDataList.push(resolvedKyungdongWblData);
                                    }
                                    else {
                                        console.error(`경동택배 송장 생성 실패 (${i + 1}/${totalQty})`);
                                    }
                                    // cleaned legacy comment
                                    if (i < totalQty - 1) {
                                        await new Promise(resolve => setTimeout(resolve, 300));
                                    }
                                }
                                if (kyungdongWblDataList.length > 0) {
                                    wblList.push(...kyungdongWblDataList);
                                    //  wblData = kyungdongWblDataList[0]; // 泥?踰덉㎏ ?≪옣??wblData濡??ㅼ젙
                                }
                                else {
                                    console.error(`경동택배 송장 생성 실패`);
                                    continue; // 실패한 경우 다음 주문으로
                                }
                                break;
                            case 'cheonil':
                                // cleaned legacy comment
                                const cheonilPrefetchedRows = cheonilWaybillMap.get(String(orderItem.orderNumber || '').trim());
                                const cheonilWblData = await createCheonilWblDataFromBatch(orderItem, cheonilPrefetchedRows);
                                if (cheonilWblData.length > 0) {
                                    // cleaned legacy comment
                                    cheonilWblData.forEach((wblDataItem, i) => {
                                        wblDataItem.sequenceNumber = index + 1 + i;
                                        wblDataItem.totalCount = orderWithLocationList.length;
                                        //wblDataItem.locationInfo = orderItem.locationInfo;
                                        //wblDataItem.productCode = orderItem.productCode;
                                        wblDataItem.courier_type = 'cheonil';
                                    });
                                    wblList.push(...cheonilWblData);
                                    // cleaned legacy comment
                                    //  wblData = cheonilWblData[0];
                                }
                                else {
                                    const fallbackCheonil = buildFallbackWaybillFromOrder(orderItem, 'cheonil', '천일 응답 없음 - 기존 tracking 사용');
                                    if (fallbackCheonil) {
                                        fallbackCheonil.sequenceNumber = index + 1;
                                        fallbackCheonil.totalCount = orderWithLocationList.length;
                                        wblList.push(fallbackCheonil);
                                        processingErrors.push(`천일 응답 없음 (${orderItem.orderNumber}) - 기존 tracking 으로 대체`);
                                    }
                                    else {
                                        processingErrors.push(`천일 운송장 데이터 없음 (${orderItem.orderNumber})`);
                                        console.error(`천일택배 송장 생성 실패`);
                                        continue; // 실패한 경우 다음 주문으로
                                    }
                                }
                                break;
                            default:
                                console.warn(`알 수 없는 택배사 ${courierType}, 한진택배로 처리합니다.`);
                                // cleaned legacy comment
                                const defaultWblResponse = await axios.post(`${API_BASE_URL}/api/proxy/print-wbl`, {
                                    order_number: orderItem.orderNumber,
                                    address: orderItem.orderData.address,
                                    zip_code: orderItem.orderData.zip_code,
                                });
                                wblData = {
                                    ...defaultWblResponse.data,
                                    sequenceNumber: index + 1,
                                    totalCount: orderWithLocationList.length,
                                    quantityIndex: orderItem.quantityIndex,
                                    boxIndex: orderItem.boxIndex,
                                    orderInfo: orderItem.orderData,
                                    orderNumber: orderItem.orderNumber,
                                    productInfo: orderItem.productData,
                                    locationInfo: orderItem.locationInfo,
                                    productCode: orderItem.productCode,
                                    courier_type: 'hanjin' // 기본값으로 한진택배 사용
                                };
                                // cleaned legacy comment
                                if (wblData) {
                                    const defaultResult = await sendToHanjin(wblData);
                                    if (defaultResult.success) {
                                    }
                                }
                                break;
                        }
                        if (wblData && courierType !== 'cheonil' && courierType !== 'kyungdong') {
                            wblList.push(wblData);
                        }
                        else if (wblData && courierType === 'kyungdong') {
                            // cleaned legacy comment
                        }
                        // Cheonil print data is generated from our own API response, so we
                        // don't need an extra fixed gap between orders.
                        if (index < orderWithLocationList.length - 1 && courierType !== 'cheonil') {
                            await new Promise(resolve => setTimeout(resolve, 500));
                        }
                    }
                    catch (error) {
                        console.error(`송장 생성 오류 (${orderItem.orderNumber}):`, error);
                        processingErrors.push(`${orderItem.orderNumber}: ${error instanceof Error ? error.message : '운송장 생성 오류'}`);
                    }
                }
                // cleaned legacy comment
                wblList.sort((a, b) => {
                    // cleaned legacy comment
                    const getLocationSort = (wblData) => {
                        if (wblData.locationInfo && wblData.locationInfo.A && wblData.locationInfo.B && wblData.locationInfo.C) {
                            // cleaned legacy comment
                            const a = String(wblData.locationInfo.A);
                            const b = String(wblData.locationInfo.B).padStart(3, '0'); // B 값을 3자리로 패딩
                            const c = String(wblData.locationInfo.C).padStart(3, '0'); // C 값을 3자리로 패딩
                            const productCode = String(wblData.productCode || '') + String(wblData.courier_type || '');
                            return { a, b, c, productCode, hasLocation: true };
                        }
                        // cleaned legacy comment
                        if (wblData.productCode) {
                            return { a: 'Z', b: 'Z', c: 'Z', productCode: String(wblData.productCode), hasLocation: false };
                        }
                        // cleaned legacy comment
                        return { a: 'Z', b: 'Z', c: 'Z', productCode: 'UNKNOWN', hasLocation: false };
                    };
                    const aSort = getLocationSort(a);
                    const bSort = getLocationSort(b);
                    // cleaned legacy comment
                    const aCompare = aSort.a.localeCompare(bSort.a, 'ko', {
                        numeric: true,
                        sensitivity: 'base',
                        caseFirst: 'upper'
                    });
                    if (aCompare !== 0)
                        return aCompare;
                    // cleaned legacy comment
                    const bCompare = aSort.b.localeCompare(bSort.b, undefined, { numeric: true });
                    if (bCompare !== 0)
                        return bCompare;
                    // cleaned legacy comment
                    const cCompare = aSort.c.localeCompare(bSort.c, undefined, { numeric: true });
                    if (cCompare !== 0)
                        return cCompare;
                    // cleaned legacy comment
                    return aSort.productCode.localeCompare(bSort.productCode, 'ko', {
                        numeric: true,
                        sensitivity: 'base'
                    });
                });
                if (wblList.length === 0 && processingErrors.length > 0) {
                    setError(processingErrors.join('\n'));
                    setLoading(false);
                    return;
                }
                if (wblList.length === 0) {
                    const hanjinOrders = orderWithLocationList.filter((item) => { var _a; return getCourierType(((_a = item === null || item === void 0 ? void 0 : item.orderData) === null || _a === void 0 ? void 0 : _a.ship_comp) || '') === 'hanjin'; });
                    if (hanjinOrders.length > 0) {
                        setError('한진 운송장 데이터를 생성하지 못했습니다.\n' +
                            '기존 tracking_number 또는 tb_orders_seq 데이터도 없어 출력할 수 없습니다.');
                    }
                    else {
                        setError('출력할 운송장 데이터가 없습니다.');
                    }
                    setLoading(false);
                    return;
                }
                hasTriggeredPrintRef.current = false;
                setWblDataList(wblList);
                setLoading(false);
                // cleaned legacy comment
                if (wblList.length > 0) {
                    const orderTrackingMap = new Map();
                    wblList.forEach((wblData) => {
                        var _a;
                        const orderNumber = (_a = wblData.orderInfo) === null || _a === void 0 ? void 0 : _a.order_number;
                        const orderData = orderWithLocationList.find((item) => item.orderNumber === orderNumber);
                        const orderId = orderData === null || orderData === void 0 ? void 0 : orderData.orderSeq;
                        if (wblData.courier_type === 'hanjin' || wblData.courier_type === 'cheonil') {
                            if (orderNumber && orderId && !orderTrackingMap.has(orderNumber)) {
                                orderTrackingMap.set(orderNumber, {
                                    order_id: orderId,
                                    tracking_no: wblData.wbl_num,
                                    orderNumber: orderNumber
                                });
                            }
                        }
                    });
                    // cleaned legacy comment
                    orderTrackingMap.forEach(async (trackingInfo) => {
                        try {
                            await axios.post(`${API_BASE_URL}/api/orders/order/update-tracking`, {
                                order_id: trackingInfo.order_id,
                                tracking_no: trackingInfo.tracking_no,
                            });
                        }
                        catch (error) {
                            console.error(`주문 ${trackingInfo.orderNumber} 원래운송장번호 업데이트 실패:`, error);
                        }
                    });
                }
            }
            catch (err) {
                console.error('주문 처리 오류:', err);
                const message = (err === null || err === void 0 ? void 0 : err.message) || '알 수 없는 오류';
                if (message.includes('한진')) {
                    setError(`한진 처리 실패: ${message}`);
                }
                else {
                    setError('주문 정보를 불러오지 못했습니다. ' + message);
                }
                setLoading(false);
            }
        };
        processOrders();
    }, []); // 빈 의존성 배열로 한 번만 실행
    // cleaned legacy comment
    useEffect(() => {
        if (wblDataList.length > 0) {
            wblDataList.forEach((wblData, index) => {
                // cleaned legacy comment
                if (tmlBarcodeRefs.current[index] && wblData.tml_cod) {
                    JsBarcode(tmlBarcodeRefs.current[index], wblData.tml_cod, {
                        format: 'CODE128',
                        width: 1.2,
                        height: 32,
                        displayValue: false,
                        margin: 0,
                    });
                }
                // cleaned legacy comment
                if (wblNumBarcodeRefs.current[index] && wblData.wbl_num) {
                    JsBarcode(wblNumBarcodeRefs.current[index], wblData.wbl_num, {
                        format: 'ITF',
                        width: 1.4,
                        height: 80,
                        displayValue: false,
                        margin: 0,
                    });
                }
            });
        }
    }, [wblDataList]);
    // cleaned legacy comment
    useEffect(() => {
        // cleaned legacy comment
        const style = document.createElement('style');
        style.textContent = `
      @page {
        size: 260mm 120mm;
        margin: 0;
        padding: 0;
      }
      
      @media print {
        * {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
        
        body {
          margin: 0 !important;
          padding: 0 !important;
          width: 260mm !important;
          height: 120mm !important;
        }
        
        .no-print {
          display: none !important;
        }
        
        .waybill-container {
          width: 260mm !important;
          height: 120mm !important;
          margin: 0 !important;
          padding: 0 !important;
          page-break-after: always;
          page-break-inside: avoid;
          break-inside: avoid;
        }
        
        .waybill-container:last-child {
          page-break-after: avoid;
          break-after: avoid;
        }
      }
      
      body {
        margin: 0;
        padding: 0;
        font-family: 'HY헤드라인M', 'Malgun Gothic', 'Arial', sans-serif;
        width: 100%;
        min-height: 100vh;
      }
      
      html, body {
        width: 100%;
        min-height: 100vh;
        overflow-x: hidden;
      }
    `;
        document.head.appendChild(style);
        // cleaned legacy comment
        const handleBeforePrint = () => {
        };
        const handleAfterPrint = () => {
            // cleaned legacy comment
            // window.close();
        };
        window.addEventListener('beforeprint', handleBeforePrint);
        window.addEventListener('afterprint', handleAfterPrint);
        return () => {
            document.head.removeChild(style);
            window.removeEventListener('beforeprint', handleBeforePrint);
            window.removeEventListener('afterprint', handleAfterPrint);
        };
    }, []);
    // cleaned legacy comment
    const silentPrint = useCallback(() => {
        var _a;
        try {
            const printWindow = window.open('', '_blank', 'width=800,height=600');
            if (printWindow) {
                const printContent = ((_a = document.querySelector('.print-content')) === null || _a === void 0 ? void 0 : _a.innerHTML) || '';
                const expectedWaybillCount = wblDataList.length;
                printWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>운송장 인쇄</title>
            <style>
              @page { 
                size: 260mm 120mm; 
                margin: 0; 
                padding: 3mm;
                -webkit-print-color-adjust: exact;
                color-adjust: exact;
              }
              
              @media print {
                * {
                  -webkit-print-color-adjust: exact !important;
                  color-adjust: exact !important;
                  print-color-adjust: exact !important;
                }
                
                body {
                  margin: 0 !important;
                  padding: 0 !important;
                  font-family: 'HY헤드라인M', 'Malgun Gothic', 'Arial', sans-serif;
                }
                
                .waybill-container {
                  width: 260mm !important;
                  height: 120mm !important;
                  min-height: 120mm !important;
                  max-height: 120mm !important;
                  margin: 0 !important;
                  padding: 0 !important;
                  page-break-after: always;
                  break-after: page;
                  page-break-inside: avoid;
                  break-inside: avoid-page;
                  border: 1px solid #000;
                  box-sizing: border-box;
                  display: block !important;
                  position: relative;
                  overflow: hidden !important;
                }
                
                .waybill-container:last-child {
                  page-break-after: avoid;
                }
                
                .no-print {
                  display: none !important;
                }
                
                .print-content {
                  width: 260mm !important;
                  margin: 0 !important;
                  padding: 0 !important;
                  height: auto;
                }
              }
              
              body {
                margin: 0;
                padding: 0;
                font-family: 'HY헤드라인M', 'Malgun Gothic', 'Arial', sans-serif;
                width: 260mm;
                height: auto;
              }

              html {
                margin: 0;
                padding: 0;
                width: 260mm;
              }

              .print-content {
                width: 260mm;
                margin: 0;
                padding: 0;
              }
              
              .waybill-container {
                width: 260mm;
                height: 120mm;
                min-height: 120mm;
                max-height: 120mm;
                margin: 0;
                padding: 0;
                page-break-after: always;
                break-after: page;
                page-break-inside: avoid;
                break-inside: avoid-page;
                border: 1px solid #000;
                box-sizing: border-box;
                display: block;
                position: relative;
                overflow: hidden;
              }
              
              .waybill-container:last-child {
                page-break-after: avoid;
              }
            </style>
            <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
          </head>
          <body>
            ${printContent}
            <script>
              // 바코드 생성
              window.onload = function() {
                // cleaned legacy comment
	                const tmlBarcodes = document.querySelectorAll('svg[data-barcode-type="tml"]');
	                const wblBarcodes = document.querySelectorAll('svg[data-barcode-type="wbl"]');
	                const eblBarcodes = document.querySelectorAll('svg[data-barcode-type="ebl"]');
	                const mainBarcodes = document.querySelectorAll('svg[data-barcode-type="main"]');
	                let lastScrollHeight = -1;
	                let stableLayoutTicks = 0;
                
                
                tmlBarcodes.forEach((svg, index) => {
                  const code = svg.getAttribute('data-code');
                  if (code && window.JsBarcode) {
                    JsBarcode(svg, code, {
                      format: 'CODE128',
                      width: 1.2,
                      height: 32,
                      displayValue: false,
                      margin: 0,
                    });
                  }
                });
                
                wblBarcodes.forEach((svg, index) => {
                  const code = svg.getAttribute('data-code');
                  if (code && window.JsBarcode) {
                    JsBarcode(svg, code, {
                      format: 'ITF',
                      width: 1.8,
                      height: 80,
                      displayValue: false,
                      margin: 0,
                    });
                  }
                });

                eblBarcodes.forEach((svg, index) => {
                  const code = svg.getAttribute('data-code');
                  if (code && window.JsBarcode) {
                    JsBarcode(svg, code, {
                      format: 'ITF',
                      width: 3,
                      height: 80,
                      displayValue: false,
                      margin: 0,
                    });
                  }
                });

                mainBarcodes.forEach((svg, index) => {
                  const code = svg.getAttribute('data-code');
                  if (code && window.JsBarcode) {
                    JsBarcode(svg, code, {
                      format: 'CODE128',
                      width: 2.3,
                      height: 55,
                      displayValue: true,
                      margin: 0,
                    });
                  }
                });
                
                
                // cleaned legacy comment
                const printWhenStable = (attempt = 0) => {
                  const expectedCount = window.__EXPECTED_WAYBILL_COUNT || 0;
                  const renderedWaybillCount = document.querySelectorAll('.waybill-container').length;
                  const currentScrollHeight = document.body ? document.body.scrollHeight : 0;

                  if (currentScrollHeight === lastScrollHeight) {
                    stableLayoutTicks += 1;
                  } else {
                    stableLayoutTicks = 0;
                    lastScrollHeight = currentScrollHeight;
                  }

                  const enoughWaybills =
                    expectedCount === 0 || renderedWaybillCount >= expectedCount;
                  const layoutStable = stableLayoutTicks >= 3;

                  if ((enoughWaybills && layoutStable) || attempt >= 120) {
                    document.title = '운송장 인쇄 ' + renderedWaybillCount + '/' + expectedCount;
                    requestAnimationFrame(() => {
                      requestAnimationFrame(() => {
                        window.print();
                        setTimeout(() => {
                          window.close();
                        }, 2000);
                      });
                    });
                    return;
                  }

                  setTimeout(() => {
                    printWhenStable(attempt + 1);
                  }, attempt < 20 ? 250 : 500);
                };

                requestAnimationFrame(() => {
                  requestAnimationFrame(() => {
                    printWhenStable(0);
                  });
                });

                if (false) {
                setTimeout(() => {
                  window.print();
                  setTimeout(() => {
                    window.close();
                  }, 2000); // 인쇄 완료 대기 시간 증가
                }, 1000); // 바코드 생성 대기 시간 증가
                }
              };
            </script>
          </body>
          </html>
        `);
                printWindow.__EXPECTED_WAYBILL_COUNT = expectedWaybillCount;
                printWindow.document.close();
                printWindow.focus();
            }
            else {
                // cleaned legacy comment
                window.print();
                // cleaned legacy comment
            }
        }
        catch (error) {
            console.error('자동 인쇄 오류:', error);
            // cleaned legacy comment
            window.print();
        }
    }, [wblDataList]);
    useEffect(() => {
        if (loading || error || wblDataList.length === 0 || hasTriggeredPrintRef.current) {
            return;
        }
        const hasCheonilWaybill = wblDataList.some((item) => item.courier_type === 'cheonil');
        if (!hasCheonilWaybill) {
            hasTriggeredPrintRef.current = true;
            const timeoutId = window.setTimeout(() => {
                silentPrint();
            }, 3000);
            return () => window.clearTimeout(timeoutId);
        }
        let cancelled = false;
        let timeoutId = null;
        let attempts = 0;
        const expectedCount = wblDataList.length;
        const tryPrintWhenReady = () => {
            if (cancelled || hasTriggeredPrintRef.current) {
                return;
            }
            attempts += 1;
            const renderedCount = document.querySelectorAll('.waybill-container').length;
            const barcodeReadyCount = wblNumBarcodeRefs.current.filter(Boolean).length;
            const isReady = renderedCount >= expectedCount &&
                barcodeReadyCount >= expectedCount;
            if (isReady || attempts >= 120) {
                hasTriggeredPrintRef.current = true;
                timeoutId = window.setTimeout(() => {
                    if (!cancelled) {
                        silentPrint();
                    }
                }, isReady ? 600 : 1200);
                return;
            }
            timeoutId = window.setTimeout(tryPrintWhenReady, 200);
        };
        timeoutId = window.setTimeout(tryPrintWhenReady, 200);
        return () => {
            cancelled = true;
            if (timeoutId !== null) {
                window.clearTimeout(timeoutId);
            }
        };
    }, [wblDataList, loading, error, silentPrint]);
    // cleaned legacy comment
    const renderWaybillByType = (wblData, index) => {
        var _a, _b;
        const courierType = getCourierType(((_a = wblData.productInfo) === null || _a === void 0 ? void 0 : _a.ship_comp) || ((_b = wblData.orderInfo) === null || _b === void 0 ? void 0 : _b.ship_comp) || '');
        switch (courierType) {
            case 'hanjin':
                return _jsx(HanjinWaybill, { wblData: wblData, index: index }, index);
            case 'kyungdong':
                return _jsx(KyungdongWaybill, { wblData: wblData, index: index }, index);
            case 'cheonil':
                return _jsx(CheonilWaybill, { wblData: wblData, index: index }, index);
            default:
                // cleaned legacy comment
                return _jsx(HanjinWaybill, { wblData: wblData, index: index }, index);
        }
    };
    if (loading) {
        return (_jsx("div", { style: {
                padding: '24px',
                fontSize: '18px',
                fontWeight: 700,
                color: '#0f172a',
                background: '#f8fafc'
            }, children: "\uC6B4\uC1A1\uC7A5 \uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uB294 \uC911..." }));
    }
    if (error) {
        const isHanjinError = error.includes('한진');
        return (_jsx("div", { style: {
                padding: '24px',
                minHeight: '100vh',
                background: isHanjinError ? '#fff1f2' : '#f8fafc',
                color: '#111827',
                fontFamily: "'Malgun Gothic', 'Arial', sans-serif"
            }, children: _jsxs("div", { style: {
                    maxWidth: '960px',
                    margin: '0 auto',
                    border: `2px solid ${isHanjinError ? '#e11d48' : '#cbd5e1'}`,
                    borderRadius: '16px',
                    background: '#fff',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                    overflow: 'hidden'
                }, children: [_jsx("div", { style: {
                            background: isHanjinError ? '#e11d48' : '#0f172a',
                            color: '#fff',
                            padding: '18px 24px',
                            fontSize: '20px',
                            fontWeight: 800
                        }, children: isHanjinError ? '한진 처리 실패' : '운송장 처리 실패' }), _jsx("div", { style: { padding: '24px', fontSize: '16px', lineHeight: 1.7, whiteSpace: 'pre-wrap' }, children: error }), isHanjinError && (_jsx("div", { style: {
                            padding: '0 24px 24px',
                            color: '#991b1b',
                            fontSize: '14px',
                            lineHeight: 1.6
                        }, children: "\uD55C\uC9C4 API\uAC00 \uD604\uC7AC \uC11C\uBC84 IP\uB97C \uD5C8\uC6A9\uD558\uC9C0 \uC54A\uC73C\uBA74 \uC1A1\uC7A5\uBC88\uD638 \uC0DD\uC131\uACFC tb_orders_seq \uC800\uC7A5\uC774 \uC9C4\uD589\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. IP \uD5C8\uC6A9 \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uBA74 \uC815\uC0C1 \uCD9C\uB825\uB429\uB2C8\uB2E4." }))] }) }));
    }
    if (wblDataList.length === 0)
        return _jsx("div", { style: { padding: 0 }, children: "\uC6B4\uC1A1\uC7A5 \uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4." });
    return (_jsx("div", { className: "print-content", children: wblDataList.map((wblData, index) => renderWaybillByType(wblData, index)) }));
};
export default PrintWblPopup;
